<div class="handbuch-wrapper">
	<header class="handbuch-header">
		<div class="header-left">
			<button class="btn btn-outline-secondary toc-menu-btn" (click)="toggleToc()" title="Inhaltsverzeichnis">
				<i class="bi" [class.bi-list]="!tocOpen" [class.bi-x]="tocOpen"></i>
			</button>
			<h1><i class="bi bi-book"></i> BpWeb Benutzerhandbuch</h1>
		</div>
		<button class="btn btn-outline-secondary" (click)="goBack()">
			<i class="bi bi-arrow-left"></i> Zurück
		</button>
	</header>

	<nav class="toc" [class.toc-open]="tocOpen">
		<!-- Suchfeld -->
		<div class="search-box mb-3">
			<div class="input-group input-group-sm">
				<span class="input-group-text"><i class="bi bi-search"></i></span>
				<input type="text"
					   #searchInput
					   class="form-control"
					   placeholder="Suchen..."
					   [(ngModel)]="searchQuery"
					   (input)="onSearch()"
					   (keydown)="onSearchKeydown($event)">
				<button *ngIf="searchResults.length > 0"
						class="btn btn-outline-secondary"
						type="button"
						(click)="goToPreviousResult()"
						title="Vorheriger Treffer">
					<i class="bi bi-chevron-up"></i>
				</button>
				<button *ngIf="searchResults.length > 0"
						class="btn btn-outline-secondary"
						type="button"
						(click)="goToNextResult()"
						title="Nächster Treffer">
					<i class="bi bi-chevron-down"></i>
				</button>
				<button *ngIf="searchQuery" class="btn btn-outline-secondary" type="button" (click)="clearSearch()">
					<i class="bi bi-x"></i>
				</button>
			</div>
			<!-- Suchergebnisse -->
			<div *ngIf="showSearchResults" class="search-results">
				<div *ngFor="let result of searchResults"
					 class="search-result-item"
					 (click)="goToResult(result)">
					<div class="search-result-section">{{ result.sectionTitle }}</div>
					<div class="search-result-context">{{ result.context }}</div>
				</div>
				<div *ngIf="searchResults.length === 0" class="search-no-results">
					Keine Treffer gefunden
				</div>
			</div>
		</div>

		<h2>Inhaltsverzeichnis
			<button class="toc-toggle-btn" (click)="tocExpanded = !tocExpanded" [title]="tocExpanded ? 'Unterkapitel ausblenden' : 'Unterkapitel einblenden'">
				<i class="bi" [class.bi-chevron-down]="!tocExpanded" [class.bi-chevron-up]="tocExpanded"></i>
			</button>
		</h2>
		<ul [class.toc-collapsed]="!tocExpanded">
			<li><a (click)="scrollTo('einfuehrung')" [class.active]="activeSection === 'einfuehrung'">1. Einführung</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('einfuehrung-zielgruppe')">Für wen ist BpWeb gedacht?</a></li>
					<li><a (click)="scrollTo('einfuehrung-grundlagen')">Fachliche Grundlagen</a></li>
					<li><a (click)="scrollTo('einfuehrung-funktionen')">Die wichtigsten Funktionen</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('karte')" [class.active]="activeSection === 'karte'">2. Kartenansicht und Werkzeuge</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('karte-bedienung')">Grundlegende Bedienung</a></li>
					<li><a (click)="scrollTo('karte-zoom')">Zoom- und Navigationswerkzeuge</a></li>
					<li><a (click)="scrollTo('karte-auswahl')">Auswahlwerkzeuge</a></li>
					<li><a (click)="scrollTo('karte-zeichnen-punkte')">Zeichenwerkzeuge – Punkte</a></li>
					<li><a (click)="scrollTo('karte-zeichnen-polygone')">Zeichenwerkzeuge – Polygone</a></li>
					<li><a (click)="scrollTo('karte-zeichnen-linien')">Zeichenwerkzeuge – Linien</a></li>
					<li><a (click)="scrollTo('karte-bearbeitung')">Bearbeitungswerkzeuge</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('projekte')" [class.active]="activeSection === 'projekte'">3. Projekte</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('projekte-panel')">Das Projekt-Panel</a></li>
					<li><a (click)="scrollTo('projekte-menu')">Projekt-Dropdown-Menü</a></li>
					<li><a (click)="scrollTo('projekte-download-status')">Download-Status</a></li>
					<li><a (click)="scrollTo('projekte-erstellen')">Projekt erstellen</a></li>
					<li><a (click)="scrollTo('benutzerrollen')">Benutzerrollen</a></li>
					<li><a (click)="scrollTo('projekte-berechtigungen')">Projekt-Berechtigungen</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('bereiche')" [class.active]="activeSection === 'bereiche'">4. Projektbereiche</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('bereiche-wozu')">Wozu dienen Bereiche?</a></li>
					<li><a (click)="scrollTo('bereiche-hinzufuegen')">Bereich hinzufügen</a></li>
					<li><a (click)="scrollTo('bereiche-steuerelemente')">Bereich-Steuerelemente</a></li>
					<li><a (click)="scrollTo('bereiche-filter')">Filter pro Bereich</a></li>
					<li><a (click)="scrollTo('bereiche-zuordnen')">Punkte über Bereiche zuordnen</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('layer')" [class.active]="activeSection === 'layer'">5. Layer und Layerstore</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('layer-typen')">Layer-Typen</a></li>
					<li><a (click)="scrollTo('layer-panel')">Layer-Panel im Projekt</a></li>
					<li><a (click)="scrollTo('layer-store')">Layerstore öffnen</a></li>
					<li><a (click)="scrollTo('layer-stile')">Zeichnungslayer-Stile</a></li>
					<li><a (click)="scrollTo('layer-punktgitter')">Punktgitter</a></li>
					<li><a (click)="scrollTo('layer-gpkg-format')">Automatische GeoPackage-Formatierung</a></li>
					<li><a (click)="scrollTo('layer-shapefile')">Shapefile-Import</a></li>
					<li><a (click)="scrollTo('layer-styling')">GeoJSON-/Shapefile-Styling</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('bohrpunktliste')" [class.active]="activeSection === 'bohrpunktliste'">6. Die Bohrpunktliste</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('liste-umfang')">Umfang-Buttons</a></li>
					<li><a (click)="scrollTo('liste-filter')">Filter-Dropdown</a></li>
					<li><a (click)="scrollTo('liste-suche')">Suchfeld</a></li>
					<li><a (click)="scrollTo('liste-auswahl')">Auswahl-Buttons</a></li>
					<li><a (click)="scrollTo('liste-einstellungen')">Listeneinstellungen</a></li>
					<li><a (click)="scrollTo('liste-eintrag')">Listeneintrag</a></li>
					<li><a (click)="scrollTo('liste-statistik')">Statistik-Leiste</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('filter')" [class.active]="activeSection === 'filter'">7. Filterfunktion</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('filter-ebenen')">Die drei Filter-Ebenen</a></li>
					<li><a (click)="scrollTo('filter-erstellen')">Filter erstellen</a></li>
					<li><a (click)="scrollTo('filter-schnell')">Schnellfilter (Freitextsuche)</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('punkte')" [class.active]="activeSection === 'punkte'">8. Bohrpunkte verwalten</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('punkte-anlegen')">Neuen Punkt anlegen</a></li>
					<li><a (click)="scrollTo('punkte-dialog')">Dialog "Neuer Punkt"</a></li>
					<li><a (click)="scrollTo('punkte-auswaehlen')">Punkte auswählen</a></li>
					<li><a (click)="scrollTo('punkte-zuordnen')">Punkte zuordnen</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('protokoll')" [class.active]="activeSection === 'protokoll'">9. Protokollansicht</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('protokoll-tabs')">Punktarten mit Protokoll</a></li>
					<li><a (click)="scrollTo('protokoll-kurz')">Punktarten mit Kurzprotokoll</a></li>
					<li><a (click)="scrollTo('protokoll-kontrolle')">Kontrollmechanismus (Kommentare)</a>
						<ul class="toc-sub">
							<li><a (click)="scrollTo('protokoll-kontrolle')">Rollen im Kontrollprozess</a></li>
							<li><a (click)="scrollTo('protokoll-kontrolle')">Kommentieren aktivieren</a></li>
							<li><a (click)="scrollTo('protokoll-kontrolle')">Kommentar-Detailansicht</a></li>
							<li><a (click)="scrollTo('protokoll-kontrolle')">Rücklauf-System</a></li>
						</ul>
					</li>
					<li><a (click)="scrollTo('protokoll-pdf')">PDF-Export</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('import')" [class.active]="activeSection === 'import'">10. Datenimport</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('import-assistent')">Import-Assistent</a></li>
					<li><a (click)="scrollTo('import-verzeichnisse')">Import (Verzeichnisse)</a></li>
					<li><a (click)="scrollTo('import-dateien')">Import (Dateien)</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('export')" [class.active]="activeSection === 'export'">11. Datenexport</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('export-json')">Export Protokolle (JSON)</a></li>
					<li><a (click)="scrollTo('export-geojson')">Export Kartendaten (GeoJSON)</a></li>
					<li><a (click)="scrollTo('export-pdf')">Export als PDF</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('offline')" [class.active]="activeSection === 'offline'">12. Offline-Modus</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('offline-voraussetzungen')">Voraussetzungen</a></li>
					<li><a (click)="scrollTo('offline-vorbereiten')">Offline vorbereiten</a></li>
					<li><a (click)="scrollTo('offline-download')">Was wird heruntergeladen?</a></li>
					<li><a (click)="scrollTo('offline-detail')">Download-Detaillierungsgrad</a></li>
					<li><a (click)="scrollTo('offline-arbeiten')">Offline arbeiten</a></li>
					<li><a (click)="scrollTo('offline-sync')">Synchronisation</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('statusanzeigen')" [class.active]="activeSection === 'statusanzeigen'">13. Statusanzeigen</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('status-verbindung')">Verbindungsstatus</a></li>
					<li><a (click)="scrollTo('status-speicher')">Speicherstatus</a></li>
					<li><a (click)="scrollTo('status-gps')">GPS-Status</a></li>
				</ul>
			</li>
			<li><a (click)="scrollTo('technik')" [class.active]="activeSection === 'technik'">14. Technischer Hintergrund</a>
				<ul class="toc-sub">
					<li><a (click)="scrollTo('technik-architektur')">Systemarchitektur</a></li>
					<li><a (click)="scrollTo('technik-datenfluss')">Datenfluss</a></li>
					<li><a (click)="scrollTo('technik-speicherung')">Datenspeicherung</a></li>
					<li><a (click)="scrollTo('technik-geodaten')">Geodatenformate</a></li>
					<li><a (click)="scrollTo('technik-koordinaten')">Koordinatensysteme</a></li>
					<li><a (click)="scrollTo('technik-pwa')">Progressive Web App</a></li>
					<li><a (click)="scrollTo('technik-sicherheit')">Sicherheit</a></li>
					<li><a (click)="scrollTo('technik-bibliotheken')">Open-Source-Bibliotheken</a></li>
					<li><a (click)="scrollTo('technik-browser')">Browser-Kompatibilität</a></li>
					<li><a (click)="scrollTo('technik-system')">Systemanforderungen</a></li>
				</ul>
			</li>
		</ul>
	</nav>

	<main class="handbuch-content">

	<!-- ====== 1. EINFÜHRUNG ====== -->
	<section id="einfuehrung">
		<h2>1. Einführung</h2>
		<p>
			Willkommen bei BpWeb! Diese Anwendung wurde speziell für die Erfassung und Verwaltung von
			Bohrpunktprotokollen im forstlichen Bereich entwickelt. Egal ob Sie im Büro am Computer
			oder mit dem Tablet im Wald arbeiten – BpWeb begleitet Sie zuverlässig bei Ihrer Arbeit.
		</p>

		<div class="info">
			<strong>Was ist BpWeb?</strong> BpWeb ist eine Progressive Web App (PWA), die wie eine
			installierte App funktioniert, aber direkt im Browser läuft. Sie können offline arbeiten,
			GPS nutzen und die App sogar auf Ihren Startbildschirm legen – ohne App Store!
		</div>

		<h3 id="einfuehrung-zielgruppe">Für wen ist BpWeb gedacht?</h3>
		<p>BpWeb richtet sich an alle, die mit forstlicher Bodenkartierung zu tun haben:</p>
		<ul>
			<li><strong>Fachbehörden:</strong> Landesforstverwaltungen und Landesbetriebe Forst, die Standortkartierungen beauftragen und auswerten</li>
			<li><strong>Kartierer/Bearbeiter:</strong> Feldarbeiter, die Bohrpunkte im Wald aufnehmen und Protokolle erfassen</li>
			<li><strong>Kontrolleure:</strong> Fachleute, die Protokolle prüfen, validieren und Feedback geben</li>
			<li><strong>Projektmanager:</strong> Administrative Nutzer, die Projekte erstellen und Benutzer verwalten</li>
			<li><strong>Forstämter und Waldbesitzer:</strong> Organisations- und Forstbetriebsleiter</li>
		</ul>

		<h3 id="einfuehrung-grundlagen">Fachliche Grundlagen – Forstliche Standortkartierung</h3>
		<p>
			Die forstliche Standortkartierung ist eine Naturrauminventur: Sie erfasst systematisch
			alle für das Waldwachstum wichtigen Faktoren wie Klima, Boden, Wasser- und Nährstoffhaushalt.
			Das Ziel ist der <strong>richtige Baum am richtigen Ort</strong> – die Grundlage für
			gesunde, stabile Wälder und eine nachhaltige Forstwirtschaft.
		</p>
		<p>
			Aus den erfassten Daten leiten sich konkrete Empfehlungen ab: Welche Baumarten sind
			geeignet? Wie sollte der Bestand gepflegt werden? Welche Risiken bestehen durch
			Trockenheit oder Vernässung? Die Standortkartierung ist damit die Schnittstelle
			zwischen Bodenkunde und waldbaulicher Praxis.
		</p>
		<p>
			BpWeb unterstützt die <strong>SEA95</strong> – die „Anleitung für die forstliche
			Standortserkundung im nordostdeutschen Tiefland" von 1995. Diese Kartieranleitung
			wird in den ostdeutschen Bundesländern angewendet und bildet dort den Standard für die
			forstliche Standortkartierung. Sie besteht aus organisatorischen und methodischen Vorgaben
			zur Durchführung der forstlichen Standorterkundung, deren geowissenschaftlicher und
			vegetationskundlicher Analyse sowie deren Auswertung und Darstellung für die Forstpraxis.
		</p>
		<div class="info">
			<strong>Die SEA95 gliedert sich in vier Teile:</strong>
			<ul style="margin-top: 0.5rem; margin-bottom: 0;">
				<li><a href="assets/SEA/SEA Teil A 02-2025.pdf" target="_blank"><strong>Teil A: Standortsformen</strong></a> –
					Grundlagenteil mit Klassifikation und Definition der Standortsformen und ihrer Teileinheiten
					für die praktische Standortserkundung</li>
				<li><a href="assets/SEA/SEA 95 Teil B, Druckvorlage_Stand_20_3_25.pdf" target="_blank"><strong>Teil B: Praktisches Arbeitsverfahren</strong></a> –
					Regelungen zur Durchführung der Standortserkundung von der Vorbereitung über Aufnahme
					und Kartierung bis zur Auswertung der Ergebnisse</li>
				<li><a href="assets/SEA/SEA Teil C Zuordnungskatalog 03-25.pdf" target="_blank"><strong>Teil C: Forstliche Auswertung</strong></a> –
					Umsetzung der Kartierungsergebnisse für die forstliche Praxis mit Standortsformengruppen,
					Baumartenwahl und Bestockungszieltypen</li>
				<li><a href="assets/SEA/SEA-D Bodenformen-Katalog_Stand 02.26.pdf" target="_blank"><strong>Teil D: Bodenformen-Katalog</strong></a> –
					Umfassender Katalog aller Bodenformen als eigenständiges Nachschlagewerk für die Kartierung
					<details style="margin-top: 0.5rem;">
						<summary style="cursor: pointer; color: #007bff;">Einzelkapitel anzeigen...</summary>
						<ul style="margin-top: 0.5rem; font-size: 0.9em;">
							<li><strong>Einführung:</strong>
								<a href="assets/SEA/SEA Teil D 02.2026/SEA-D Bodenformen-Katalog Einführung_02.26.pdf" target="_blank">Einführung</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/04Datenverzeichnis für Bodenformen(S.31-39)_02-26.pdf" target="_blank">Datenverzeichnis</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/04SeaDFeinbodenfverz_(S.40-80)_02-26.pdf" target="_blank">Feinbodenformenverzeichnis</a>
							</li>
							<li><strong>Anhydromorphe Böden:</strong>
								<a href="assets/SEA/SEA Teil D 02.2026/Anhydromorphe Böden_02.26.pdf" target="_blank">Gesamtkapitel</a> |
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro1Sandböden_02.26.pdf" target="_blank">Sand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro2Bändersandböden_02-26.pdf" target="_blank">Bändersand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro3Lehmsandböden_02_26.pdf" target="_blank">Lehmsand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro4Staubsandböden_02-26.pdf" target="_blank">Staubsand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro5Bänderstaubsandböden_02-26.pdf" target="_blank">Bänderstaubsand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro6Grandböden_02-26.pdf" target="_blank">Grand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro7Bändergrandböden_02-26.pdf" target="_blank">Bändergrand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro8Skelettböden_02-26.pdf" target="_blank">Skelett</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro9Kalkböden_02-26.pdf" target="_blank">Kalk</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro10Lehmböden_02-26.pdf" target="_blank">Lehm</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/05Anhydro11Tonböden_02-26.pdf" target="_blank">Ton</a>
							</li>
							<li><strong>Halbgley-Böden:</strong>
								<a href="assets/SEA/SEA Teil D 02.2026/Halbgleye_02-26.pdf" target="_blank">Gesamtkapitel</a> |
								<a href="assets/SEA/SEA Teil D 02.2026/06Halbgley1Sandböden_02-26.pdf" target="_blank">Sand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/06Halbgley2Skelettböden_02-26.pdf" target="_blank">Skelett</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/06Halbgley3Lehmböden_02-26.pdf" target="_blank">Lehm</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/06Halbgley4DeckTieflehmböden_02-26.pdf" target="_blank">Deck-/Tieflehm</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/06Halbgley5Tonböden_02-26.pdf" target="_blank">Ton</a>
							</li>
							<li><strong>Graugley-Böden:</strong>
								<a href="assets/SEA/SEA Teil D 02.2026/Graugleye_02-26.pdf" target="_blank">Gesamtkapitel</a> |
								<a href="assets/SEA/SEA Teil D 02.2026/07Graugley1Sandböden_02-26.pdf" target="_blank">Sand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/07Graugley2Kalkböden_02-26.pdf" target="_blank">Kalk</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/07Graugley3Lehmböden(S374-392)_02-25.pdf" target="_blank">Lehm</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/07Graugley4Tonböden_02-26.pdf" target="_blank">Ton</a>
							</li>
							<li><strong>Humusgley-Böden:</strong>
								<a href="assets/SEA/SEA Teil D 02.2026/Humusgleye_02-26.pdf" target="_blank">Gesamtkapitel</a> |
								<a href="assets/SEA/SEA Teil D 02.2026/08Humusgley1Sandböden-02-26.pdf" target="_blank">Sand</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/08Humusgley2Skelettböden_02-26.pdf" target="_blank">Skelett</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/08Humusgley3Kalkböden_02-26.pdf" target="_blank">Kalk</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/08Humusgley4Lehmböden_02-26.pdf" target="_blank">Lehm</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/08Humusgley5Tonböden_02-26.pdf" target="_blank">Ton</a>
							</li>
							<li><strong>Weitere:</strong>
								<a href="assets/SEA/SEA Teil D 02.2026/09Moore(S461)_neu_01-25.pdf" target="_blank">Moore</a>,
								<a href="assets/SEA/SEA Teil D 02.2026/10 Komplexstandorte_02-26.pdf" target="_blank">Komplexstandorte</a>
							</li>
						</ul>
					</details>
				</li>
			</ul>
		</div>
		<div class="tip" id="sea-offline-hint">
			<strong>Offline-Verfügbarkeit:</strong> Die SEA-Dokumente sind im Offline-Modus nur verfügbar, wenn sie vorher in den Cache geladen wurden. Dafür gibt es zwei Wege:
			<ul class="mb-2 mt-1">
				<li>Über den Button <em>„In den Cache laden"</em> (unten) alle Dokumente direkt herunterladen.</li>
				<li>Beim Offline-Bereitstellen eines Projekts den Haken bei <em>„SEA-Dokumente herunterladen"</em> setzen.</li>
			</ul>
			<button class="btn btn-sm btn-outline-primary" (click)="downloadSeaDocs()" [disabled]="seaDownloadStatus === 'downloading'">
				<i class="bi me-1" [class.bi-cloud-download]="seaDownloadStatus !== 'downloading'" [class.bi-arrow-repeat]="seaDownloadStatus === 'downloading'" [class.spin]="seaDownloadStatus === 'downloading'"></i>
				{{ seaDownloadStatus === 'idle' ? 'In den Cache laden' : seaDownloadStatus === 'downloading' ? seaDownloadProgress : seaDownloadStatus === 'done' ? 'Fertig' : 'Fehler' }}
			</button>
		</div>

		<h3 id="einfuehrung-funktionen">Die wichtigsten Funktionen im Überblick</h3>
		<div class="feature-list">
			<div class="feature-card">
				<h4><i class="bi bi-folder"></i> Projektbasiert</h4>
				<p>Organisieren Sie Ihre Arbeit in Projekten mit Bereichen, Layern und Filtern.
				Laden Sie gezielt die Daten herunter, die Sie im Gelände benötigen.</p>
			</div>
			<div class="feature-card">
				<h4><i class="bi bi-wifi-off"></i> Offline-fähig</h4>
				<p>Kein Handyempfang im Wald? Kein Problem! Bereiten Sie Projekte vor und
				arbeiten Sie vollständig offline. Synchronisation erfolgt automatisch.</p>
			</div>
			<div class="feature-card">
				<h4><i class="bi bi-layers"></i> Layersystem</h4>
				<p>WMS-Dienste, GeoPackage, GeoTIFF, GeoJSON und eigene Zeichnungslayer –
				alles in einem flexiblen Layersystem mit Offline-Support.</p>
			</div>
			<div class="feature-card">
				<h4><i class="bi bi-funnel"></i> Dreifache Filter</h4>
				<p>Filtern Sie Punkte global, pro Bereich oder über Flächenauswahl.
				Speichern und wiederverwenden Sie Ihre Filter.</p>
			</div>
		</div>

		<div class="tip">
			<strong>Für Einsteiger:</strong> Lesen Sie unbedingt Kapitel 3 (Projekte) zuerst!
			Das Projektkonzept ist zentral für die gesamte Anwendung.
		</div>
	</section>

	<!-- ====== 2. KARTENANSICHT UND WERKZEUGE ====== -->
	<section id="karte">
		<h2>2. Kartenansicht und Werkzeuge</h2>
		<p>
			Die Karte ist die zentrale Arbeitsumgebung in BpWeb. Hier sehen Sie Ihre Bohrpunkte,
			navigieren durch Ihre Projektgebiete und nutzen verschiedene Werkzeuge. Die
			Werkzeugleiste bietet umfangreiche Funktionen für Auswahl, Zeichnung und Punkterstellung.
		</p>

		<h3 id="karte-bedienung">Grundlegende Bedienung</h3>
		<table class="shortcut-table">
			<tr>
				<th>Aktion</th>
				<th>Maus/Tastatur</th>
				<th>Touch (Tablet/Handy)</th>
			</tr>
			<tr>
				<td><strong>Karte verschieben</strong></td>
				<td>Linke Maustaste gedrückt halten und ziehen</td>
				<td>Mit einem Finger wischen</td>
			</tr>
			<tr>
				<td><strong>Hineinzoomen</strong></td>
				<td>Mausrad nach oben / Doppelklick / + Button</td>
				<td>Zwei Finger auseinanderziehen</td>
			</tr>
			<tr>
				<td><strong>Herauszoomen</strong></td>
				<td>Mausrad nach unten / - Button</td>
				<td>Zwei Finger zusammenziehen</td>
			</tr>
			<tr>
				<td><strong>Punkt auswählen</strong></td>
				<td>Auf Punkt klicken</td>
				<td>Auf Punkt tippen</td>
			</tr>
			<tr>
				<td><strong>Mehrfachauswahl</strong></td>
				<td><kbd>Strg</kbd> + Klick auf weitere Punkte</td>
				<td>Auswahlwerkzeug verwenden</td>
			</tr>
		</table>

		<div class="info">
			<strong>Punkte-Darstellung:</strong> Bohrpunkte werden als Symbole auf der Karte angezeigt.
			Der Status eines Punktes wird durch farbige Ringe (Halos) um das Symbol dargestellt:
			<ul style="margin-top: 0.5rem;">
				<li><span style="color: #00c800; font-weight: bold;">Grüner Kreis (innen):</span> Punkt ist dem Projekt zugeordnet</li>
				<li><span style="color: #003cb4; font-weight: bold;">Blauer Ring (mitte):</span> Punkt ist ausgewählt</li>
				<li><span style="color: #ff8c00; font-weight: bold;">Oranger Ring (außen):</span> Punkt entspricht dem aktiven Filter</li>
			</ul>
			Bei Clustern (gruppierten Punkten) zeigt ein farbiger Ring um den Cluster an, dass
			mindestens ein Punkt im Cluster den jeweiligen Status hat.
			<br/><br/>
			Unter jedem Punkt wird ein rotes Label mit <strong>Nährkraftstufe und Stammfeuchtestufe</strong>
			angezeigt (z.B. „Z2"), sofern die entsprechenden Daten im Protokoll eingetragen sind.
		</div>

		<h3 id="karte-zoom">Zoom- und Navigationswerkzeuge</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Werkzeug</th>
				<th>Verwendung</th>
			</tr>
			<tr>
				<td><i class="bi bi-plus-lg"></i> / <i class="bi bi-dash-lg"></i></td>
				<td><strong>Zoom +/-</strong></td>
				<td>Karte vergrößern/verkleinern</td>
			</tr>
			<tr>
				<td><i class="bi bi-search"></i></td>
				<td><strong>Zoom zu...</strong></td>
				<td>Öffnet die Zoom-Werkzeuggruppe</td>
			</tr>
			<tr>
				<td><i class="bi bi-geo-fill"></i></td>
				<td><strong>GPS-Position</strong></td>
				<td>Zur aktuellen GPS-Position fliegen</td>
			</tr>
			<tr>
				<td><i class="bi bi-house"></i></td>
				<td><strong>Projektbereich</strong></td>
				<td>Zum gesamten Projektbereich zoomen</td>
			</tr>
			<tr>
				<td><i class="bi bi-check2-square"></i></td>
				<td><strong>Zur Auswahl</strong></td>
				<td>Zu den ausgewählten Punkten zoomen</td>
			</tr>
			<tr>
				<td><i class="bi bi-funnel"></i></td>
				<td><strong>Zum Filter</strong></td>
				<td>Zu allen gefilterten Punkten zoomen</td>
			</tr>
			<tr>
				<td><i class="bi bi-aspect-ratio"></i></td>
				<td><strong>Zoom aufziehen</strong></td>
				<td>Rechteck für Zoombereich aufziehen</td>
			</tr>
		</table>

		<h3 id="karte-auswahl">Auswahlwerkzeuge</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Werkzeug</th>
				<th>Verwendung</th>
			</tr>
			<tr>
				<td><img src="assets/img/selection.svg" style="width: 20px; height: 20px;" alt="Auswahl"></td>
				<td><strong>Auswahl</strong></td>
				<td>Öffnet die Auswahlwerkzeug-Gruppe</td>
			</tr>
			<tr>
				<td><i class="bi bi-square"></i></td>
				<td><strong>Rechteck-Auswahl</strong></td>
				<td>Ziehen Sie ein Rechteck auf. Alle Punkte darin werden ausgewählt.</td>
			</tr>
			<tr>
				<td><i class="bi bi-pentagon"></i></td>
				<td><strong>Polygon-Auswahl</strong></td>
				<td>Klicken Sie Eckpunkte. Polygon schließt sich automatisch bei Nähe zum Start.</td>
			</tr>
			<tr>
				<td><img src="assets/img/draw-polygon-freehand.svg" style="width: 20px; height: 20px;" alt="Freihand"></td>
				<td><strong>Freihand-Auswahl</strong></td>
				<td>Zeichnen Sie freihändig einen Bereich. Gut für unregelmäßige Flächen.</td>
			</tr>
			<tr>
				<td><i class="bi bi-check-lg" style="color: green;"></i></td>
				<td><strong>Abschließen</strong></td>
				<td>Beendet die Polygon-Auswahl (erscheint ab 3 Eckpunkten)</td>
			</tr>
			<tr>
				<td><i class="bi bi-x-lg" style="color: red;"></i></td>
				<td><strong>Auswahl aufheben</strong></td>
				<td>Deselektiert alle ausgewählten Punkte</td>
			</tr>
			<tr>
				<td><i class="bi bi-hand-index-thumb"></i></td>
				<td><strong>Navigieren</strong></td>
				<td>Pan/Zoom-Modus – alle Werkzeuge abwählen</td>
			</tr>
		</table>

		<h3 id="karte-zeichnen-punkte">Zeichenwerkzeuge – Punkte</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Werkzeug</th>
				<th>Verwendung</th>
			</tr>
			<tr>
				<td><img src="assets/img/draw-point.svg" style="width: 20px; height: 20px;" alt="Punkt"></td>
				<td><strong>Neuer Punkt</strong></td>
				<td>Öffnet die Punkt-Werkzeuggruppe</td>
			</tr>
			<tr>
				<td><i class="bi bi-geo-alt-fill"></i></td>
				<td><strong>Punkt am Standort</strong></td>
				<td>Erstellt einen neuen Punkt an Ihrer aktuellen GPS-Position</td>
			</tr>
			<tr>
				<td><i class="bi bi-circle"></i></td>
				<td><strong>Punkt auf Karte</strong></td>
				<td>Klicken Sie auf die Karte, um dort einen neuen Punkt zu erstellen</td>
			</tr>
		</table>

		<h3 id="karte-zeichnen-polygone">Zeichenwerkzeuge – Polygone</h3>

		<div class="info">
			<strong>Aktiver Zeichnungslayer:</strong> Alle Zeichenwerkzeuge arbeiten nur im aktiven Zeichnungslayer.
			Wenn Sie mehrere Zeichnungslayer haben, müssen Sie im Layer-Panel (Bleistift-Symbol <i class="bi bi-pencil"></i>)
			auswählen, in welchem Layer Sie zeichnen möchten. Bei nur einem Zeichnungslayer erfolgt die Aktivierung automatisch.
			Der zuletzt verwendete Layer wird gespeichert und beim nächsten Zeichnen automatisch wieder aktiviert.
		</div>

		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Werkzeug</th>
				<th>Verwendung</th>
			</tr>
			<tr>
				<td><img src="assets/img/draw-polygon.svg" style="width: 20px; height: 20px;" alt="Polygon"></td>
				<td><strong>Polygon</strong></td>
				<td>Öffnet die Polygon-Werkzeuggruppe</td>
			</tr>
			<tr>
				<td><img src="assets/img/draw-polygon-nodes.svg" style="width: 20px; height: 20px;" alt="Knoten"></td>
				<td><strong>Polygon (Knoten)</strong></td>
				<td>Klicken Sie für jeden Eckpunkt, Doppelklick zum Beenden</td>
			</tr>
			<tr>
				<td><img src="assets/img/draw-polygon-freehand.svg" style="width: 20px; height: 20px;" alt="Freihand"></td>
				<td><strong>Polygon (Freihand)</strong></td>
				<td>Zeichnen Sie freihändig, beim Loslassen wird das Polygon geschlossen</td>
			</tr>
			<tr>
				<td><img src="assets/img/footprint.svg" style="width: 20px; height: 20px;" alt="GPS"></td>
				<td><strong>Polygon (GPS-Tracking)</strong></td>
				<td>Laufen Sie den Bereich ab – GPS zeichnet automatisch den Weg auf</td>
			</tr>
		</table>

		<h3 id="karte-zeichnen-linien">Zeichenwerkzeuge – Linien</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Werkzeug</th>
				<th>Verwendung</th>
			</tr>
			<tr>
				<td><img src="assets/img/draw-line.svg" style="width: 20px; height: 20px;" alt="Linie"></td>
				<td><strong>Linie</strong></td>
				<td>Öffnet die Linien-Werkzeuggruppe</td>
			</tr>
			<tr>
				<td><img src="assets/img/draw-line-nodes.svg" style="width: 20px; height: 20px;" alt="Knoten"></td>
				<td><strong>Linie (Knoten)</strong></td>
				<td>Klicken Sie für jeden Stützpunkt, Doppelklick zum Beenden</td>
			</tr>
			<tr>
				<td><img src="assets/img/draw-line-freehand.svg" style="width: 20px; height: 20px;" alt="Freihand"></td>
				<td><strong>Linie (Freihand)</strong></td>
				<td>Zeichnen Sie freihändig eine Linie</td>
			</tr>
			<tr>
				<td><img src="assets/img/footprint.svg" style="width: 20px; height: 20px;" alt="GPS"></td>
				<td><strong>Linie (GPS-Tracking)</strong></td>
				<td>Laufen Sie einen Weg ab – GPS zeichnet automatisch die Route auf</td>
			</tr>
		</table>

		<h3 id="karte-bearbeitung">Bearbeitungswerkzeuge</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Werkzeug</th>
				<th>Verwendung</th>
			</tr>
			<tr>
				<td><i class="bi bi-wrench"></i></td>
				<td><strong>Bearbeiten</strong></td>
				<td>Klicken Sie auf eine Zeichnung, um ihre Knoten zu verschieben</td>
			</tr>
			<tr>
				<td><i class="bi bi-eraser"></i></td>
				<td><strong>Löschen</strong></td>
				<td>Klicken Sie auf eine Zeichnung, um sie zu entfernen</td>
			</tr>
			<tr>
				<td><i class="bi bi-check-lg" style="color: green;"></i></td>
				<td><strong>Änderungen übernehmen</strong></td>
				<td>Speichert die Bearbeitung</td>
			</tr>
			<tr>
				<td><i class="bi bi-x-lg"></i></td>
				<td><strong>Abbrechen</strong></td>
				<td>Verwirft alle nicht gespeicherten Änderungen</td>
			</tr>
		</table>

		<div class="tip">
			<strong>GPS-Tracking-Tipp:</strong> Das GPS-Tracking ist ideal für das Ablaufen von
			Bestandesgrenzen oder Wegen im Gelände. Starten Sie das Tracking, laufen Sie den Bereich
			ab, und stoppen Sie am Ende. Die Route wird automatisch als Linie oder Polygon gespeichert.
		</div>

		<div class="info">
			<strong>Zeichnungen werden synchronisiert:</strong> Ihre Zeichnungen werden in der
			Datenbank gespeichert und mit dem Server synchronisiert. Sie sind also nicht nur lokal,
			sondern auch nach einem Gerätewechsel verfügbar!
		</div>
	</section>

	<!-- ====== 3. PROJEKTE ====== -->
	<section id="projekte">
		<h2>3. Projekte – Das zentrale Konzept</h2>
		<p>
			<strong>Projekte sind der Dreh- und Angelpunkt von BpWeb.</strong> Jeder Bohrpunkt gehört
			zu einem Projekt. Ein Projekt definiert, welche Daten heruntergeladen werden, wer Zugriff
			hat und wie die Punkte organisiert sind.
		</p>

		<h3 id="projekte-panel">Das Projekt-Panel</h3>
		<p>
			Das Projekt-Panel befindet sich fest am rechten Bildschirmrand der Kartenansicht. Es lässt sich
			über den Pfeil-Button oben ein- und ausklappen. Im eingeklappten Zustand erscheint eine
			schmale Leiste mit dem vertikalen Schriftzug „Projektmenü" – ein Klick darauf öffnet das
			Panel wieder. Das Ein- und Ausklappen erfolgt mit einer sanften Slide-Animation.
		</p>
		<p>
			Das Panel ist als Akkordeon aufgebaut mit zwei aufklappbaren Bereichen:
		</p>
		<table class="shortcut-table">
			<tr>
				<th>Bereich</th>
				<th>Funktion</th>
			</tr>
			<tr>
				<td><strong>Bereiche</strong></td>
				<td>Geografische Regionen des Projekts definieren und verwalten</td>
			</tr>
			<tr>
				<td><strong>Layer</strong></td>
				<td>Kartenebenen, Geodaten und Zeichnungslayer verwalten</td>
			</tr>
		</table>

		<h3 id="projekte-menu">Projekt-Dropdown-Menü</h3>
		<p>
			Über das Drei-Punkte-Menü <i class="bi bi-three-dots-vertical"></i> neben dem Projektnamen
			erreichen Sie folgende Funktionen:
		</p>
		<table class="shortcut-table">
			<tr>
				<th>Menüpunkt</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><i class="bi bi-plus-circle"></i> <strong>Neues Projekt...</strong></td>
				<td>Erstellt ein neues Projekt (nur für Manager)</td>
			</tr>
			<tr>
				<td><i class="bi bi-pencil"></i> <strong>Bearbeiten</strong></td>
				<td>Projektname, Beschreibung und Benutzer bearbeiten</td>
			</tr>
			<tr>
				<td><i class="bi bi-x-circle"></i> <strong>Schließen</strong></td>
				<td>Projekt schließen (wechselt zur Projektauswahl)</td>
			</tr>
			<tr>
				<td><i class="bi bi-trash"></i> <strong>Löschen</strong></td>
				<td>Löscht das Projekt dauerhaft (nur für Manager)</td>
			</tr>
			<tr>
				<td><i class="bi bi-cloud-download"></i> <strong>Download</strong></td>
				<td>Lädt Karten-Tiles, Punkte und Geodaten für Offline-Nutzung herunter</td>
			</tr>
		</table>

		<h3 id="projekte-download-status">Download-Status</h3>
		<p>Der Download-Status zeigt an, welche Offline-Daten vorhanden sind:</p>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Status</th>
				<th>Bedeutung</th>
			</tr>
			<tr>
				<td><i class="bi bi-cloud" style="color: gray"></i></td>
				<td>Keine Daten</td>
				<td>Projekt noch nicht heruntergeladen</td>
			</tr>
			<tr>
				<td><i class="bi bi-cloud-download-fill" style="color: red"></i></td>
				<td>Teilweise</td>
				<td>Download wurde unterbrochen oder unvollständig</td>
			</tr>
			<tr>
				<td><i class="bi bi-cloud-check" style="color: green"></i></td>
				<td>Vollständig</td>
				<td>Alle Daten für Offline-Nutzung vorhanden</td>
			</tr>
			<tr>
				<td><i class="bi bi-folder-x" style="color: red"></i></td>
				<td>Geodaten fehlen</td>
				<td>Tiles und Punkte OK, aber Geodaten-Dateien fehlen</td>
			</tr>
		</table>

		<div class="warning">
			<strong>Vollständiger Download erforderlich:</strong> Um offline arbeiten zu können,
			müssen alle drei Komponenten heruntergeladen sein: Karten-Tiles, Punkte und Geodaten.
			Nur dann ist der Status "Vollständig" (grünes Symbol).
		</div>

		<h3 id="projekte-erstellen">Projekt erstellen</h3>
		<p>Als Projektmanager können Sie neue Projekte anlegen:</p>
		<ol>
			<li>Klicken Sie im Projekt-Dropdown auf <strong>Neues Projekt...</strong></li>
			<li>Geben Sie einen <strong>Projektnamen</strong> ein (muss eindeutig sein)</li>
			<li>Optional: Fügen Sie eine <strong>Beschreibung</strong> hinzu</li>
			<li>Weisen Sie <strong>Bearbeiter</strong> und <strong>Kontrolleure</strong> zu</li>
			<li>Klicken Sie auf <strong>Erstellen</strong></li>
		</ol>

		<h3 id="benutzerrollen">Benutzerrollen</h3>
		<p>
			Das System unterscheidet verschiedene Benutzerrollen mit unterschiedlichen Berechtigungen.
			Die Rolle wird vom Administrator bei der Benutzerverwaltung festgelegt.
		</p>

		<h4>Rollenbeschreibungen</h4>
		<table class="shortcut-table">
			<tr>
				<th>Rolle</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Entwickler</strong></td>
				<td>Vollzugriff auf alle Funktionen (Administrator)</td>
			</tr>
			<tr>
				<td><strong>Manager</strong></td>
				<td>Projektverwaltung, keine Datenerfassung</td>
			</tr>
			<tr>
				<td><strong>Kontrolleur</strong></td>
				<td>Qualitätskontrolle, Punkte prüfen und korrigieren</td>
			</tr>
			<tr>
				<td><strong>Kartierer</strong></td>
				<td>Feldarbeit, Punkte erfassen und bearbeiten</td>
			</tr>
			<tr>
				<td><strong>Datennutzer</strong></td>
				<td>Nur Lesezugriff auf Punkte und Layer</td>
			</tr>
			<tr>
				<td><strong>Gast</strong></td>
				<td>Eingeschränkter Lesezugriff, anonymisierte Daten</td>
			</tr>
		</table>

		<h4>Berechtigungsübersicht nach Rolle</h4>
		<table class="shortcut-table">
			<tr>
				<th>Berechtigung</th>
				<th>Entwickler</th>
				<th>Manager</th>
				<th>Kontrolleur</th>
				<th>Kartierer</th>
				<th>Datennutzer</th>
				<th>Gast</th>
			</tr>
			<tr>
				<td colspan="7" class="category"><strong>Punkte</strong></td>
			</tr>
			<tr>
				<td>Anlegen</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Lesen</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓*</td>
			</tr>
			<tr>
				<td>Bearbeiten</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Löschen</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Importieren</td>
				<td class="center">✓</td>
				<td class="center">✓**</td>
				<td class="center">–</td>
				<td class="center">✓**</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td colspan="7" class="category"><strong>Zeichnungen</strong></td>
			</tr>
			<tr>
				<td>Erstellen/Bearbeiten</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td colspan="7" class="category"><strong>Layer & Filter</strong></td>
			</tr>
			<tr>
				<td>Layer anzeigen</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Filter verwenden</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td colspan="7" class="category"><strong>Kommentare</strong></td>
			</tr>
			<tr>
				<td>Lesen/Schreiben</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td colspan="7" class="category"><strong>Projekte</strong></td>
			</tr>
			<tr>
				<td>Alle Projekte sehen</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Projekt erstellen</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Projekt löschen</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Bereiche definieren</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
			<tr>
				<td>Offline bereitstellen</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">✓</td>
				<td class="center">–</td>
				<td class="center">–</td>
			</tr>
		</table>
		<p class="footnote">
			* Gast: Kartierer und Aufnahmedatum werden anonymisiert angezeigt<br>
			** Nur wenn die Projekt-Berechtigung "Importieren" aktiviert ist
		</p>

		<div class="tip">
			<strong>Typische Rollenverteilung im Projekt:</strong>
			<ul>
				<li><strong>Kartierer:</strong> Feldarbeiter, die Bohrpunkte aufnehmen und Protokolle erfassen</li>
				<li><strong>Kontrolleur:</strong> Prüft erfasste Daten und gibt Feedback</li>
				<li><strong>Manager:</strong> Verwaltet Projekte, Bereiche und Mitglieder</li>
			</ul>
		</div>

		<h3 id="projekte-berechtigungen">Projekt-Berechtigungen</h3>
		<p>
			Im Dialog "Projekt bearbeiten" können detaillierte Berechtigungen für alle Projektmitglieder
			festgelegt werden:
		</p>
		<table class="shortcut-table">
			<tr>
				<th>Berechtigung</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Anlegen</strong></td>
				<td>Neue Bohrpunkte im Projekt erstellen</td>
			</tr>
			<tr>
				<td><strong>Löschen</strong></td>
				<td>Bohrpunkte aus der Datenbank löschen</td>
			</tr>
			<tr>
				<td><strong>Importieren</strong></td>
				<td>Punkte über den Import-Assistenten hinzufügen</td>
			</tr>
			<tr>
				<td><strong>Ändern</strong></td>
				<td>Bestehende Protokolle bearbeiten</td>
			</tr>
			<tr>
				<td><strong>Zuordnen</strong></td>
				<td>Punkte dem Projekt zuordnen oder entfernen</td>
			</tr>
			<tr>
				<td><strong>Bereiche anlegen</strong></td>
				<td>Neue Projektbereiche definieren</td>
			</tr>
			<tr>
				<td><strong>Bereiche löschen</strong></td>
				<td>Bestehende Projektbereiche entfernen</td>
			</tr>
		</table>
		<div class="info">
			<strong>Berechtigung "Zuordnen":</strong> Mit dieser Berechtigung kann gesteuert werden,
			wer Punkte zum Projekt hinzufügen oder aus dem Projekt entfernen darf. Dies ist unabhängig
			von der Berechtigung "Anlegen" (neue Punkte erstellen) oder "Löschen" (Punkte aus der
			Datenbank löschen).
			<br><br>
			<strong>Hintergrund:</strong> Vorhandene Bohrpunkte sollen nur mit Berechtigung geändert werden können.
			Die Zuordnung zu einem Projekt stellt sicher, dass nur berechtigte Nutzer Punkte bearbeiten können.
			<br><br>
			<strong>Hinweis:</strong> Auch ohne Zuordnungsberechtigung können Punkte im Viewonly-Modus betrachtet
			und in ein Offline-Projekt übernommen werden.
		</div>
	</section>

	<!-- ====== 4. BEREICHE ====== -->
	<section id="bereiche">
		<h2>4. Projektbereiche (Regions)</h2>
		<p>
			Projektbereiche definieren die geografischen Gebiete Ihres Projekts. Sie sind wichtig
			für den Offline-Download und die regionale Filterung.
		</p>

		<h3 id="bereiche-wozu">Wozu dienen Bereiche?</h3>
		<ul>
			<li><strong>Tile-Download:</strong> Nur Karten-Tiles innerhalb der Bereiche werden heruntergeladen</li>
			<li><strong>Regionale Filter:</strong> Jedem Bereich kann ein eigener Filter zugewiesen werden</li>
			<li><strong>Übersichtlichkeit:</strong> Große Projekte in überschaubare Teile gliedern</li>
		</ul>

		<h3 id="bereiche-hinzufuegen">Bereich hinzufügen</h3>
		<p>Es gibt mehrere Wege, einen Bereich zu definieren:</p>
		<ol>
			<li><strong>Rechteck auswählen:</strong>
				<br>Klicken Sie auf <i class="bi bi-square"></i>&nbsp;<strong>Rechteck</strong> und ziehen Sie ein Rechteck auf der Karte auf</li>
			<li><strong>Polygon zeichnen:</strong>
				<br>Klicken Sie auf <i class="bi bi-pentagon"></i>&nbsp;<strong>Polygon</strong> und zeichnen Sie einen Bereich ein</li>
			<li><strong>Freihand zeichnen:</strong>
				<br>Klicken Sie auf <img src="assets/img/draw-polygon-freehand.svg" style="height: 1em; vertical-align: middle;">&nbsp;<strong>Freihand</strong> und zeichnen Sie einen Bereich frei</li>
			<li><strong>Datei importieren:</strong>
				<br>Klicken Sie auf <i class="bi bi-file-earmark-arrow-up"></i>&nbsp;<strong>Importieren</strong> um bestehende
				Gebietsgrenzen zu importieren. Unterstützte Formate: GeoJSON, GeoPackage (.gpkg), Shapefile (.shp/.zip)</li>
		</ol>

		<div class="info">
			<strong>Automatische Verarbeitung beim Import:</strong>
			<ul class="mb-0 mt-2">
				<li><strong>Polygonanzahl-Obergrenze:</strong> Maximal 500 Polygone können importiert werden.
					Bei Überschreitung wird der Import abgebrochen.</li>
				<li><strong>Zusammenfassen:</strong> Bei mehr als 10 Polygonen werden nahe beieinander
					liegende Bereiche automatisch zu Clustern zusammengefasst (max. 20 Bereiche).</li>
				<li><strong>Konvexe Hülle:</strong> Für zusammengefasste Cluster wird eine konvexe Hülle
					berechnet, damit alle benötigten Kartenkacheln erfasst werden.</li>
				<li><strong>Puffer:</strong> Um jedes Polygon wird automatisch ein 200m-Puffer hinzugefügt.</li>
				<li><strong>Mindestgröße:</strong> Sehr kleine Polygone werden zu Rechtecken
					mit mindestens 400m Kantenlänge erweitert.</li>
			</ul>
		</div>

		<h3 id="bereiche-steuerelemente">Bereich-Steuerelemente</h3>
		<p>Jeder Bereich in der Liste hat folgende Steuerelemente (von links nach rechts):</p>

		<h4>Zwei Schiebeschalter</h4>
		<table class="shortcut-table">
			<tr>
				<th>Schalter</th>
				<th>Funktion</th>
			</tr>
			<tr>
				<td><strong>Sync</strong> (links)</td>
				<td>Aktiviert den Bereich für die Offline-Synchronisation. Nur aktivierte Bereiche
					werden beim Download berücksichtigt.</td>
			</tr>
			<tr>
				<td><strong>Zuordnen</strong> (Mitte)</td>
				<td>Ordnet alle Punkte innerhalb des Bereichs dem Projekt zu. Wird der Schalter
					deaktiviert, werden die Punkte wieder aus dem Projekt entfernt.</td>
			</tr>
		</table>

		<h4>Aktions-Buttons</h4>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Aktion</th>
			</tr>
			<tr>
				<td><i class="bi bi-search"></i></td>
				<td>Zum Bereich zoomen – zentriert die Karte auf diesen Bereich</td>
			</tr>
			<tr>
				<td><i class="bi bi-trash"></i></td>
				<td>Bereich löschen (in der Kopfzeile: Alle Bereiche löschen)</td>
			</tr>
		</table>

		<h4>Weitere Elemente</h4>
		<ul>
			<li><strong>Namensfeld:</strong> Textfeld zum Umbenennen des Bereichs</li>
			<li><strong>Fläche:</strong> Zeigt die Größe des Bereichs in Hektar an</li>
			<li><strong>Filter-Dropdown:</strong> Weist dem Bereich einen Filter zu (nur sichtbar wenn kein globaler Filter aktiv)</li>
			<li><strong>Punktzahl-Badge:</strong> Zeigt die Anzahl der (gefilterten) Punkte im Bereich an</li>
		</ul>

		<h3 id="bereiche-filter">Filter pro Bereich</h3>
		<p>
			Mit der Filter-Funktion können Sie die Punktanzahl pro Bereich einschränken.
			Dies wirkt sich auf mehrere Funktionen aus:
		</p>

		<h4>Filter erstellen</h4>
		<p>
			Klicken Sie auf das <i class="bi bi-funnel"></i> <strong>Trichter-Symbol</strong> neben dem
			<i class="bi bi-info-circle"></i> Info-Symbol, um Filter zu erstellen oder zu bearbeiten.
			Filter können nach verschiedenen Kriterien definiert werden:
		</p>
		<ul>
			<li>Bohrpunkttyp (z.B. nur Bodenprofil, nur Sondierung)</li>
			<li>Status (z.B. nur abgeschlossene Punkte)</li>
			<li>Kartierer (z.B. nur eigene Punkte)</li>
			<li>Datum (z.B. nur Punkte aus einem bestimmten Zeitraum)</li>
			<li>Und viele weitere Kriterien...</li>
		</ul>

		<h4>Filter pro Bereich anwenden</h4>
		<p>
			In der Spalte <strong>„Filter"</strong> können Sie für jeden Bereich einen der erstellten
			Filter auswählen. Die Punktanzahl in der Spalte <strong>„Anz."</strong> zeigt dann nur noch
			die Punkte an, die dem Filter entsprechen.
		</p>

		<h4>Auswirkungen der Filter</h4>
		<table class="shortcut-table">
			<tr>
				<th>Funktion</th>
				<th>Auswirkung</th>
			</tr>
			<tr>
				<td><strong>Offline-Sync</strong></td>
				<td>Nur die gefilterten Punkte werden für die Offline-Synchronisation berücksichtigt</td>
			</tr>
			<tr>
				<td><strong>Projektzuordnung</strong></td>
				<td>Der Schalter „zuordnen" ordnet nur die gefilterten Punkte dem Projekt zu</td>
			</tr>
			<tr>
				<td><strong>Punktzahl</strong></td>
				<td>Das Badge zeigt die Anzahl der gefilterten Punkte im Bereich</td>
			</tr>
		</table>

		<div class="tip">
			<strong>Beispiel:</strong> Sie haben einen großen Bereich mit 500 Punkten. Mit einem Filter
			„Nur zur Prüfung" reduzieren Sie die Anzeige auf z.B. 23 Punkte. Beim Aktivieren des
			Sync-Schalters werden nur diese 23 Punkte synchronisiert.
		</div>

		<h3 id="bereiche-zuordnen">Punkte über Bereiche zuordnen</h3>
		<p>
			Mit dem <strong>Zuordnen-Schalter</strong> (zweiter Schiebeschalter von links) können Sie
			alle Punkte innerhalb eines Bereichs mit einem Klick dem Projekt zuordnen:
		</p>
		<ul>
			<li><strong>Schalter aktivieren:</strong> Alle Punkte im Bereich werden dem Projekt zugeordnet</li>
			<li><strong>Schalter deaktivieren:</strong> Alle Punkte im Bereich werden aus dem Projekt entfernt</li>
		</ul>
		<p>
			Diese Funktion ist besonders praktisch, wenn Sie einen neuen Projektbereich definiert haben
			und alle darin liegenden Punkte auf einmal zuweisen möchten.
		</p>

		<div class="tip">
			<strong>Berechtigung erforderlich:</strong> Für die Zuordnung von Punkten benötigen Sie
			die Berechtigung "Zuordnen" im Projekt (siehe Kapitel 2: Projekt-Berechtigungen).
		</div>
	</section>

	<!-- ====== 5. LAYER ====== -->
	<section id="layer">
		<h2>5. Layer und Layerstore</h2>
		<p>
			BpWeb unterstützt verschiedene Kartenebenen (Layer), die Sie flexibel ein- und
			ausblenden können. Der Layerstore ermöglicht das Hinzufügen eigener Geodaten.
		</p>

		<h3 id="layer-typen">Layer-Typen</h3>
		<table class="shortcut-table">
			<tr>
				<th>Typ</th>
				<th>Beschreibung</th>
				<th>Offline</th>
			</tr>
			<tr>
				<td><strong>OSM</strong></td>
				<td>OpenStreetMap Basiskarte</td>
				<td>Ja (nach Download)</td>
			</tr>
			<tr>
				<td><strong>WMS</strong></td>
				<td>Web Map Service (externe Kartendienste)</td>
				<td>Ja (nach Download)</td>
			</tr>
			<tr>
				<td><strong>GeoPackage</strong></td>
				<td>Vektordaten (.gpkg) mit Attributen</td>
				<td>Ja</td>
			</tr>
			<tr>
				<td><strong>GeoTIFF</strong></td>
				<td>Georeferenzierte Rasterbilder</td>
				<td>Ja</td>
			</tr>
			<tr>
				<td><strong>GeoJSON</strong></td>
				<td>Vektordaten im JSON-Format</td>
				<td>Ja</td>
			</tr>
			<tr>
				<td><strong>Shapefile</strong></td>
				<td>Vektordaten (.shp mit .dbf/.prj oder als .zip)</td>
				<td>Ja</td>
			</tr>
			<tr>
				<td><strong>Punktgitter</strong></td>
				<td>Regelmäßiges Raster für Orientierung</td>
				<td>Ja</td>
			</tr>
			<tr>
				<td><strong>Zeichnungslayer</strong></td>
				<td>Eigene Zeichnungen (Linien, Polygone)</td>
				<td>Ja</td>
			</tr>
		</table>

		<h3 id="layer-panel">Layer-Panel im Projekt</h3>
		<p>
			Im Layer-Bereich des Projekt-Panels können Sie:
		</p>
		<ul>
			<li><strong>Sichtbarkeit umschalten:</strong> Klicken Sie auf das Augen-Symbol</li>
			<li><strong>Reihenfolge ändern:</strong> Ziehen Sie Layer per Drag & Drop. Die Reihenfolge im Menü entspricht der Stapelung auf der Karte – Layer weiter oben liegen über den darunter liegenden.</li>
			<li><strong>Zu Layer zoomen:</strong> Klicken Sie auf das Zoom-Symbol</li>
			<li><strong>Style bearbeiten:</strong> Klicken Sie auf das Farbkästchen (für Zeichnungs-, GeoPackage- und GeoJSON-Layer)</li>
			<li><strong>Zeichnungslayer aktivieren:</strong> Klicken Sie auf das Bleistift-Symbol (<i class="bi bi-pencil"></i>), um einen Zeichnungslayer für die Bearbeitung auszuwählen. Alle Zeichenwerkzeuge arbeiten dann nur in diesem Layer.</li>
		</ul>

		<div class="tip">
			<strong>Zuletzt aktiver Zeichnungslayer:</strong> Der zuletzt verwendete Zeichnungslayer wird mit einem
			gelben Rahmen markiert und automatisch aktiviert, wenn Sie ein Zeichenwerkzeug starten. So müssen Sie nicht
			jedes Mal den Layer manuell auswählen. Bei nur einem Zeichnungslayer erfolgt die Aktivierung immer automatisch.
		</div>

		<h3 id="layer-store">Layerstore öffnen</h3>
		<p>
			Der Layerstore ist ein Dialog zum Hinzufügen und Verwalten von Layern:
		</p>
		<ul>
			<li><strong>WMS-Dienste:</strong> Fügen Sie WMS-URLs hinzu und wählen Sie Layer aus</li>
			<li><strong>Geodaten-Dateien:</strong> Laden Sie GeoPackage, GeoTIFF, GeoJSON oder Shapefile hoch (siehe automatische Formatierung unten)</li>
			<li><strong>Zeichnungslayer:</strong> Erstellen Sie neue Layer für Ihre Zeichnungen</li>
			<li><strong>Punktgitter:</strong> Konfigurieren Sie ein regelmäßiges Raster</li>
		</ul>

		<h3 id="layer-stile">Zeichnungslayer-Stile</h3>
		<p>
			Für Zeichnungslayer können Sie den Stil anpassen:
		</p>
		<table class="shortcut-table">
			<tr>
				<th>Eigenschaft</th>
				<th>Beschreibung</th>
				<th>Wertebereich</th>
			</tr>
			<tr>
				<td><strong>Linienfarbe</strong></td>
				<td>Farbe der Umrisslinien</td>
				<td>16 vordefinierte Farben</td>
			</tr>
			<tr>
				<td><strong>Linienstärke</strong></td>
				<td>Breite der Linien</td>
				<td>1-8 Pixel</td>
			</tr>
			<tr>
				<td><strong>Füllfarbe</strong></td>
				<td>Füllfarbe bei Polygonen</td>
				<td>16 vordefinierte Farben</td>
			</tr>
			<tr>
				<td><strong>Deckkraft</strong></td>
				<td>Transparenz der Füllung</td>
				<td>0% - 100%</td>
			</tr>
		</table>

		<h3 id="layer-punktgitter">Punktgitter</h3>
		<p>
			Das Punktgitter zeigt ein regelmäßiges Raster auf der Karte – hilfreich für
			systematische Kartierungen:
		</p>
		<ul>
			<li><strong>Auflösung:</strong> 1-10 Hektar pro Punkt (Standard: 5 ha)</li>
			<li><strong>Radius:</strong> 1-10 Pixel (Standard: 3 px)</li>
			<li><strong>Farbe:</strong> Frei wählbar</li>
			<li><strong>Deckkraft:</strong> 0-100%</li>
		</ul>

		<div class="tip">
			<strong>WMS-Regionen:</strong> BpWeb filtert WMS-Dienste nach Ihrer aktuellen Position.
			Je nachdem ob Sie in Brandenburg (BB), Mecklenburg-Vorpommern (MV) oder anderswo in
			Deutschland (DE) arbeiten, werden passende Dienste angezeigt.
		</div>

		<h3 id="layer-gpkg-format">Automatische GeoPackage-Formatierung</h3>
		<p>
			GeoPackage-Layer mit Standort- oder Humusform-Attributen werden automatisch erkannt
			und mit speziellen Labels versehen. Die Erkennung erfolgt anhand der Attributnamen:
		</p>
		<h4>Standort-Layer</h4>
		<p>Erkennungsmerkmal: Attribut <code>LBFO1</code> oder <code>STGR1</code> vorhanden.</p>
		<p>Darstellung: Rote Umrisslinie mit mehrzeiligem Label.</p>
		<p><strong>Verwendete Felder:</strong></p>
		<ul>
			<li><code>LBFO1</code>, <code>SUBF1</code> – Lokalbodenform und Substratfeuchte (1. Wert)</li>
			<li><code>STGR1</code>, <code>SUB1</code> – Stamm-Standortformengruppe und Substratgruppe (1. Wert)</li>
			<li><code>LBFO2</code>, <code>SUBF2</code>, <code>STGR2</code>, <code>SUB2</code> – optionaler 2. Wert</li>
			<li><code>STO_ANT1</code>, <code>STO_ANT2</code> – Anteile in Prozent (werden in zusätzlicher Zeile angezeigt)</li>
		</ul>

		<h4>Humusform-Layer</h4>
		<p>Erkennungsmerkmal: Attribut <code>HUFO1</code> vorhanden.</p>
		<p>Darstellung: Grüne Umrisslinie mit Label.</p>
		<p><strong>Verwendete Felder:</strong></p>
		<ul>
			<li><code>HUFO1</code> – Humusform (1. Wert)</li>
			<li><code>HUFO2</code> – optionaler 2. Wert</li>
			<li><code>HU_ANT1</code>, <code>HU_ANT2</code> – Anteile in Prozent (werden in zusätzlicher Zeile angezeigt)</li>
		</ul>

		<p>
			Labels werden ab Zoomstufe 15 angezeigt und weichen automatisch Punkt-Labels
			und anderen GPKG-Labels aus.
		</p>

		<h3 id="layer-shapefile">Shapefile-Import</h3>
		<p>
			Shapefiles können auf zwei Arten importiert werden:
		</p>
		<ul>
			<li><strong>Als ZIP-Datei:</strong> Laden Sie eine .zip-Datei hoch, die alle Shapefile-Komponenten enthält (.shp, .dbf, .prj, etc.)</li>
			<li><strong>Als Einzeldateien:</strong> Wählen Sie die .shp-Datei zusammen mit den zugehörigen .dbf und .prj Dateien aus (Mehrfachauswahl)</li>
		</ul>
		<p>
			Die .prj-Datei ist wichtig für die korrekte Koordinatentransformation. Ohne sie werden
			die Koordinaten als WGS84 interpretiert, was zu Verschiebungen führen kann.
		</p>

		<h3 id="layer-styling">GeoJSON-/Shapefile-Styling</h3>
		<p>
			GeoJSON- und Shapefile-Layer können wie Zeichnungslayer gestylt werden.
			Klicken Sie auf das Farbkästchen neben dem Layernamen im Projektmenü, um
			Linienfarbe, Linienstärke, Füllfarbe und Deckkraft anzupassen.
		</p>
	</section>

	<!-- ====== 6. BOHRPUNKTLISTE ====== -->
	<section id="bohrpunktliste">
		<h2>6. Die Bohrpunktliste</h2>
		<p>
			Die Bohrpunktliste befindet sich am linken Bildschirmrand und lässt sich über den
			Pfeil-Button oben ein- und ausklappen. Im eingeklappten Zustand ist die Leiste als
			schmaler Streifen mit dem vertikalen Schriftzug „Bohrpunktliste" sichtbar – ein Klick
			darauf öffnet die Liste wieder. Das Ein- und Ausklappen erfolgt mit einer sanften Animation.
			Auf sehr kleinen Bildschirmen öffnet sich die Liste im Vollbild.
		</p>
		<p>
			Die Liste zeigt Bohrpunkte mit Symbol, Nummer und Kartierer an. Ein Klick
			auf einen Eintrag zentriert die Karte auf diesen Punkt. Ein Klick auf das Symbol
			rechts öffnet direkt die Protokollansicht des Punktes.
		</p>

		<h3 id="liste-umfang">Umfang-Buttons</h3>
		<p>Die drei Buttons oben bestimmen, welche Punkte in der Liste angezeigt werden:</p>
		<table class="shortcut-table">
			<tr>
				<th>Button</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Alle</strong></td>
				<td>Zeigt alle Punkte in der Datenbank</td>
			</tr>
			<tr>
				<td><strong>Karte</strong></td>
				<td>Zeigt nur Punkte im aktuellen Kartenausschnitt</td>
			</tr>
			<tr>
				<td><strong>Auswahl</strong></td>
				<td>Zeigt nur die ausgewählten Punkte</td>
			</tr>
		</table>

		<h3 id="liste-filter">Filter-Dropdown</h3>
		<p>
			Das Filter-Dropdown ermöglicht die Auswahl eines gespeicherten Filters.
			Ein aktiver Filter wird blau hervorgehoben. Die Optionen:
		</p>
		<ul>
			<li><strong>Kein Filter:</strong> Zeigt alle Punkte ohne Einschränkung</li>
			<li><strong>Alle Projektpunkte:</strong> Zeigt nur Punkte des aktuellen Projekts</li>
			<li><strong>Gespeicherte Filter:</strong> Ihre eigenen Filter (siehe Kapitel 8)</li>
			<li><strong>Filter bearbeiten...:</strong> Öffnet die Filterverwaltung</li>
		</ul>

		<h3 id="liste-suche">Suchfeld</h3>
		<p>
			Das Suchfeld durchsucht mehrere Felder gleichzeitig: Nummer, Forstamt, Revier,
			Kartierer, Punktart, Jahr, Vegetation, FBF, HBF und Humusform.
			Ein aktiver Suchbegriff wird durch Hintergrundfarbe angezeigt.
		</p>

		<h3 id="liste-auswahl">Auswahl-Buttons</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Funktion</th>
			</tr>
			<tr>
				<td><i class="bi bi-plus-lg" style="color: green"></i></td>
				<td>Alle sichtbaren Punkte zur Auswahl hinzufügen</td>
			</tr>
			<tr>
				<td><i class="bi bi-dash-lg" style="color: red"></i></td>
				<td>Sichtbare Punkte aus der Auswahl entfernen</td>
			</tr>
			<tr>
				<td><i class="bi bi-arrow-left-right"></i></td>
				<td>Auswahl der sichtbaren Punkte umkehren</td>
			</tr>
			<tr>
				<td><i class="bi bi-x-circle"></i></td>
				<td>Gesamte Auswahl aufheben</td>
			</tr>
			<tr>
				<td><i class="bi bi-gear"></i></td>
				<td>Listeneinstellungen öffnen</td>
			</tr>
		</table>

		<h3 id="liste-einstellungen">Listeneinstellungen</h3>
		<p>Über das Zahnrad-Symbol öffnen Sie die Einstellungen:</p>
		<ul>
			<li><strong>Nur Punkte mit Protokoll anzeigen:</strong> Blendet Kurzprotokoll-Punkte aus</li>
			<li><strong>Nach oben sortieren:</strong> Bestimmte Punkte an den Anfang der Liste sortieren:
				<ul>
					<li><em>Keine:</em> Standard-Sortierung ohne Priorisierung</li>
					<li><em>Ausgewählte Punkte:</em> Ausgewählte Punkte zuerst anzeigen</li>
					<li><em>Dem Projekt zugeordnete Punkte:</em> Punkte des aktuellen Projekts zuerst</li>
					<li><em>Gefilterte Punkte:</em> Vom Filter erfasste Punkte zuerst</li>
				</ul>
			</li>
			<li><strong>Sortierung:</strong> Nach Typ, Nummer, Bearbeiter oder Datum</li>
			<li><strong>Symbol-Legende:</strong> Aufklappbare Übersicht aller Punktsymbole</li>
		</ul>

		<h3 id="liste-eintrag">Listeneintrag</h3>
		<p>Jeder Punkt wird mit folgenden Informationen angezeigt:</p>
		<ul>
			<li><strong>Symbol:</strong> Punktart-Symbol (z.B. Tiefbohrung, Moorpunkt)</li>
			<li><strong>Nummer:</strong> Bohrpunktnummer (falls vorhanden)</li>
			<li><strong>Protokoll-Button:</strong> <i class="bi bi-file-text"></i> öffnet das Protokoll</li>
			<li><strong>Kartierer:</strong> Name des Bearbeiters</li>
		</ul>
		<p>
			Ausgewählte Punkte werden <span style="background-color: #6dd5ed; padding: 2px 4px;">blau hinterlegt</span>,
			gefilterte Punkte <span style="background-color: #ffc107; padding: 2px 4px;">gelb hinterlegt</span>.
		</p>

		<h3 id="liste-statistik">Statistik-Leiste</h3>
		<p>Am unteren Rand zeigt eine Statistik-Leiste die Anzahl der Punkte:</p>
		<table class="shortcut-table">
			<tr>
				<th>Kürzel</th>
				<th>Bedeutung</th>
			</tr>
			<tr>
				<td><strong>G:</strong></td>
				<td>Gesamtanzahl aller Punkte</td>
			</tr>
			<tr>
				<td><strong style="color: #98d8a0">K:</strong></td>
				<td>Punkte im Kartenausschnitt</td>
			</tr>
			<tr>
				<td><strong style="color: #ffc107">F:</strong></td>
				<td>Gefilterte Punkte</td>
			</tr>
			<tr>
				<td><strong style="color: #6dd5ed">A:</strong></td>
				<td>Ausgewählte Punkte</td>
			</tr>
		</table>
		<p>
			Klicken Sie auf <i class="bi bi-info-circle"></i> für eine Erklärung der Statistik-Werte.
		</p>
	</section>

	<!-- ====== 8. FILTER ====== -->
	<section id="filter">
		<h2>7. Die dreifache Filterfunktion</h2>
		<p>
			BpWeb bietet ein mächtiges, dreistufiges Filtersystem in der Bohrpunktliste.
			Diese drei Ebenen arbeiten zusammen, um Ihnen genau die Punkte zu zeigen, die Sie brauchen.
		</p>

		<h3 id="filter-ebenen">Die drei Filter-Ebenen</h3>
		<table class="shortcut-table">
			<tr>
				<th>Ebene</th>
				<th>Position</th>
				<th>Verwendung</th>
			</tr>
			<tr>
				<td><strong>1. Umfang (Alle/Karte/Auswahl)</strong></td>
				<td>Button-Gruppe oben</td>
				<td>
					<ul style="margin: 0; padding-left: 1rem;">
						<li><strong>Alle:</strong> Zeigt alle Punkte im Projekt</li>
						<li><strong>Karte:</strong> Zeigt nur Punkte im aktuellen Kartenausschnitt</li>
						<li><strong>Auswahl:</strong> Zeigt nur ausgewählte Punkte</li>
					</ul>
				</td>
			</tr>
			<tr>
				<td><strong>2. Gespeicherte Filter</strong></td>
				<td>Dropdown "Filter"</td>
				<td>Wählen Sie einen gespeicherten Filter aus (z.B. "Zur Prüfung", "Eigene Punkte")</td>
			</tr>
			<tr>
				<td><strong>3. Schnellfilter</strong></td>
				<td>Suchfeld</td>
				<td>Freitextsuche in Nr, Amt, Revier... – filtert die Liste sofort</td>
			</tr>
		</table>

		<div class="info">
			<strong>Filterung ist kumulativ:</strong> Alle drei Ebenen werden kombiniert angewendet.
			Beispiel: Sie wählen "Karte" + Filter "Eigene Punkte" + Schnellfilter "123" –
			dann sehen Sie nur Ihre eigenen Punkte im Kartenausschnitt, deren Nummer "123" enthält.
		</div>

		<h3 id="filter-erstellen">Filter erstellen und verwalten</h3>
		<ol>
			<li>Öffnen Sie das Filter-Dropdown und klicken Sie auf <i class="bi bi-pencil-square"></i></li>
			<li>Klicken Sie auf <strong>Neuer Filter</strong></li>
			<li>Geben Sie einen Namen ein</li>
			<li>Fügen Sie Bedingungen hinzu:
				<ul>
					<li>Wählen Sie ein <strong>Feld</strong> (z.B. Punktart, Status, Kartierer)</li>
					<li>Wählen Sie einen <strong>Operator</strong> (=, ≠, enthält, beginnt mit, etc.)</li>
					<li>Geben Sie den <strong>Vergleichswert</strong> ein</li>
				</ul>
			</li>
			<li>Verbinden Sie mehrere Bedingungen mit <strong>UND</strong> oder <strong>ODER</strong></li>
			<li>Klicken Sie auf <strong>Speichern</strong></li>
		</ol>

		<h3 id="filter-schnell">Schnellfilter (Freitextsuche)</h3>
		<p>
			Das Suchfeld <i class="bi bi-search"></i> durchsucht mehrere Felder gleichzeitig:
		</p>
		<ul>
			<li>Punktnummer</li>
			<li>Forstamt/Forstbetrieb</li>
			<li>Revier</li>
			<li>Adresse</li>
		</ul>

		<div class="warning">
			<strong>Filter in Verwendung:</strong> Filter, die in einem Projekt aktiv sind
			(global, regional oder in einer Flächenauswahl), können nicht gelöscht werden.
			Entfernen Sie zuerst die Verwendung im Projekt.
		</div>

		<div class="tip">
			<strong>Beispiel-Filter:</strong>
			<ul>
				<li>"Eigene Punkte": Kartierer = [Ihr Name]</li>
				<li>"Zur Prüfung": Status = "Zur Prüfung"</li>
				<li>"Tiefbohrungen Brandenburg": Punktart = "Tiefbohrung" UND Forstamt beginnt mit "B"</li>
			</ul>
		</div>
	</section>

	<!-- ====== 9. PUNKTE VERWALTEN ====== -->
	<section id="punkte">
		<h2>8. Bohrpunkte verwalten</h2>

		<h3 id="punkte-anlegen">Einen neuen Punkt anlegen</h3>
		<p>Es gibt mehrere Wege, einen neuen Bohrpunkt zu erstellen:</p>

		<h4>Weg 1: Über das Menü</h4>
		<ol>
			<li>Öffnen Sie das Menü <i class="bi bi-list"></i></li>
			<li>Wählen Sie <strong>Neuer Punkt</strong></li>
			<li>Der Dialog zur Punkterstellung öffnet sich – der Punkt wird an Ihrer aktuellen GPS-Position erstellt</li>
		</ol>

		<h4>Weg 2: Punkt an GPS-Position</h4>
		<ol>
			<li>Klicken Sie in der Werkzeugleiste auf <img src="assets/img/draw-point.svg" style="height: 1em; vertical-align: middle;"> und dann auf <i class="bi bi-geo-alt-fill"></i></li>
			<li>Der Punkt wird an Ihrer aktuellen GPS-Position erstellt</li>
		</ol>

		<h4>Weg 3: Punkt auf Karte setzen</h4>
		<ol>
			<li>Klicken Sie in der Werkzeugleiste auf <img src="assets/img/draw-point.svg" style="height: 1em; vertical-align: middle;"> und dann auf <i class="bi bi-circle"></i></li>
			<li>Klicken Sie auf die gewünschte Position in der Karte</li>
			<li>Der Dialog zur Punkterstellung öffnet sich mit den Koordinaten</li>
		</ol>

		<h3 id="punkte-dialog">Dialog "Neuer Punkt"</h3>
		<p>Im Dialog geben Sie die Grunddaten ein:</p>
		<table class="shortcut-table">
			<tr>
				<th>Feld</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Punktart</strong></td>
				<td>Tiefbohrung (6), Moorpunkt (7), Sonderstandort (150), Kurzprotokoll, etc.</td>
			</tr>
			<tr>
				<td><strong>Nummer</strong></td>
				<td>Eindeutige Punktnummer (nur bei bestimmten Punktarten)</td>
			</tr>
			<tr>
				<td><strong>Aufnahmedatum</strong></td>
				<td>Datum der Kartierung (Voreinstellung: heute)</td>
			</tr>
			<tr>
				<td><strong>Kartierer</strong></td>
				<td>Ihr Name (wird automatisch eingetragen)</td>
			</tr>
		</table>

		<p>Nach der Eingabe haben Sie zwei Optionen:</p>
		<ul>
			<li><strong>Anlegen:</strong> Punkt wird erstellt, Sie bleiben auf der Karte</li>
			<li><strong>Öffnen:</strong> Punkt wird erstellt und sofort zur Bearbeitung geöffnet</li>
		</ul>

		<div class="info">
			<strong>Automatische Daten:</strong> Beim Anlegen eines Punktes werden folgende Informationen
			automatisch erfasst (sofern verfügbar):
			<ul style="margin-top: 0.5rem; margin-bottom: 0;">
				<li><strong>Koordinaten</strong> – per GPS oder aus der Kartenposition</li>
				<li><strong>Projekt</strong> – das aktuell geöffnete Projekt wird zugewiesen</li>
				<li><strong>Kartierer</strong> – der angemeldete Benutzer</li>
				<li><strong>Witterung</strong> – aktuelle Wetterdaten vom Wetterdienst (Temperatur, Niederschlag, Bewölkung)</li>
				<li><strong>Forstliche Adresse</strong> – Forstamt, Revier, Abteilung, Unterabteilung, Teilfläche, Hilfsfläche (aus WMS-Diensten MV und BB)</li>
				<li><strong>Gemarkung/Flurstück</strong> – Gemarkung, Flur, Flurstück (aus WMS-Diensten MV)</li>
				<li><strong>Klimastufe</strong> – aus der Standortkarte (WMS MV)</li>
				<li><strong>Wuchsgebiet/Wuchsbezirk</strong> – aus dem bundesweiten Wuchsgebietsdienst</li>
			</ul>
		</div>

		<h3 id="punkte-auswaehlen">Punkte auswählen</h3>
		<ul>
			<li><strong>Einzelauswahl:</strong> Klicken Sie auf einen Punkt</li>
			<li><strong>Mehrfachauswahl:</strong> <kbd>Strg</kbd> + Klick oder Auswahlwerkzeuge</li>
			<li><strong>Alle auswählen:</strong> <kbd>Strg</kbd> + <kbd>A</kbd></li>
		</ul>

		<h3 id="punkte-zuordnen">Punkte dem Projekt zuordnen</h3>
		<p>
			Sie können ausgewählte Punkte dem aktuellen Projekt zuordnen oder wieder entfernen.
			Voraussetzung ist die Berechtigung "Zuordnen" im Projekt.
		</p>

		<h4>Einzelne Punkte zuordnen</h4>
		<ul>
			<li>Rechtsklick auf einen Punkt → <strong>Dem Projekt zuordnen</strong></li>
			<li>Oder: Punkt öffnen → Im Tab "Allgemein" das Projekt hinzufügen</li>
		</ul>

		<h4>Mehrere Punkte gleichzeitig zuordnen (Bulk-Zuordnung)</h4>
		<ol>
			<li>Wählen Sie die gewünschten Punkte aus (Auswahlwerkzeuge oder <kbd>Strg</kbd> + Klick)</li>
			<li>Öffnen Sie das Menü <i class="bi bi-list"></i></li>
			<li>Wählen Sie <strong>Auswahl → Dem Projekt zuordnen</strong></li>
		</ol>
		<p>Analog können Sie mit <strong>Auswahl → Aus Projekt entfernen</strong> mehrere Punkte
		gleichzeitig aus dem Projekt entfernen.</p>

		<h4>Bereichs-Zuordnung</h4>
		<p>
			Im Bereiche-Panel gibt es für jeden Bereich einen <strong>Zuordnen-Schiebeschalter</strong>
			(zweiter Schalter von links). Aktivieren Sie diesen, um alle Punkte innerhalb des Bereichs
			automatisch dem Projekt zuzuordnen. Deaktivieren entfernt die Punkte wieder aus dem Projekt.
		</p>

		<div class="tip">
			<strong>Zugewiesene Punkte erkennen:</strong> Punkte, die dem aktuellen Projekt zugeordnet
			sind, werden auf der Karte mit einem <span style="color: #4CAF50; font-weight: bold;">grünen Ring</span>
			markiert. In der Bohrpunktliste können Sie diese über die Einstellung "Nach oben sortieren →
			Dem Projekt zugeordnete Punkte" priorisieren.
		</div>

	</section>

	<!-- ====== 9. PROTOKOLLANSICHT ====== -->
	<section id="protokoll">
		<h2>9. Protokollansicht</h2>
		<p>
			Die Protokollansicht ist in Tabs (Registerkarten) unterteilt. Welche Tabs angezeigt
			werden, hängt von der Punktart ab. Bei vielen Eingabefeldern finden Sie ein Info-Symbol
			(<i class="bi bi-info-circle"></i>), das Hilfestellungen und Erläuterungen zum jeweiligen Feld anzeigt.
		</p>

		<h3 id="protokoll-tabs">Punktarten mit vollständigem Protokoll</h3>
		<p>
			Punktarten 1-4, 6 (Tiefbohrung), 7 (Moorpunkt), 70 und 150 (Sonderstandort) haben folgende Tabs:
		</p>

		<h4>Tab: Allgemein</h4>
		<table class="shortcut-table">
			<tr>
				<th>Bereich</th>
				<th>Felder</th>
			</tr>
			<tr>
				<td><strong>Aufnahme</strong></td>
				<td>Punktart, Datum, Nummer, Kartierer, Labornummer, Projekt(e) als Chips mit Entfernen-Button</td>
			</tr>
			<tr>
				<td><strong>Adresse</strong></td>
				<td>Forstamt, Revier, Forstbetrieb, Abteilung/UA/TF, Gemarkung/Flur/Flurstück</td>
			</tr>
			<tr>
				<td><strong>Naturraum</strong></td>
				<td>Wuchsgebiet/-bezirk, Geologie, Klimastufe, Moortyp, Relief, Mesoklima, Morphologie, KMgCaP-Serie, Witterung</td>
			</tr>
			<tr>
				<td><strong>Bemerkungen</strong></td>
				<td>Bestand (Baumarten), Bemerkungen</td>
			</tr>
		</table>

		<h4>Tab: Boden</h4>
		<table class="shortcut-table">
			<tr>
				<th>Bereich</th>
				<th>Felder</th>
			</tr>
			<tr>
				<td><strong>Substratfolge</strong></td>
				<td>Tiefe, Mächtigkeit, Wechselschichtung, Torfarten, Substrat, Zersetzungsgrad, Konsistenz, Humusgehalt, Lagerungsdichte, Skelettgehalt, Karbonat, Farbe, nWSK</td>
			</tr>
			<tr>
				<td><strong>Horizontfolge</strong></td>
				<td>Tiefe, Mächtigkeit, Horizonte (1-3 pro Schicht)</td>
			</tr>
			<tr>
				<td><strong>Bodenform</strong></td>
				<td>HBF, FBF, STFG, Humusform, Humusauflage (Ol, Of, Oh), Wasserform, Saugsaum, Spiegeltiefe, Karbonattiefe, nWSK/nWSK-Stufe, pH, V-Wert, Entwässerung, Substratfeuchte, Moormächtigkeit (nur Moorpunkte, automatisch berechnet)</td>
			</tr>
		</table>

		<h4>Tab: Vegetation</h4>
		<table class="shortcut-table">
			<tr>
				<th>Bereich</th>
				<th>Felder</th>
			</tr>
			<tr>
				<td><strong>Schichtanteile</strong></td>
				<td>Prozentuale Anteile der Vegetationsschichten</td>
			</tr>
			<tr>
				<td><strong>Vegetationsaufnahme</strong></td>
				<td>Schicht (Baum, Strauch, Kraut, Moos), Art, Häufigkeit (%)</td>
			</tr>
			<tr>
				<td><strong>Humusauflage</strong></td>
				<td>Humusform/Vegetationsformengruppe, Ol, Of, Oh, Bemerkungen</td>
			</tr>
		</table>
		<div class="info">
			<strong>Vegetationsliste:</strong> Als gültige Werte für die Vegetationsaufnahme sind Einträge der
			<a href="https://germansl.infinitenature.org/" target="_blank">GermanSL</a> hinterlegt
			(gekürzt um Subspezies und Varianten).
		</div>

		<h4>Tab: Karte</h4>
		<p>
			Zeigt den Punkt auf einer interaktiven Karte im eingeschränkten Modus (ohne Zeichenwerkzeuge
			und Projektmenü). Sie können die Lage des Punktes manuell anpassen, indem Sie die Karte
			unter dem Fadenkreuz in der Kartenmitte verschieben. Unterhalb der Karte zeigt eine Koordinatenleiste
			das aktuelle Koordinatensystem sowie die X- und Y-Koordinaten an.
		</p>
		<div class="info">
			<strong>Koordinaten verwerfen:</strong> Wenn Sie die Position verschoben haben, aber die
			Änderung nicht speichern möchten, klicken Sie einfach auf <strong>Zurück</strong> →
			<strong>Verwerfen</strong>. Die Koordinaten werden automatisch auf den ursprünglichen
			Wert zurückgesetzt.
		</div>

		<h4>Ungespeicherte Änderungen</h4>
		<p>
			Wenn Sie ein Protokoll mit ungespeicherten Änderungen verlassen, erscheint ein Dialog mit drei Optionen:
		</p>
		<ul>
			<li><strong>Bleiben</strong> – Sie bleiben im Protokoll und können weiterarbeiten</li>
			<li><strong>Verwerfen</strong> – Änderungen werden verworfen, Sie kehren zur Übersicht zurück</li>
			<li><strong>Speichern &amp; zurück</strong> – Änderungen werden gespeichert, dann kehren Sie zurück</li>
		</ul>

		<h4>Tab: Plausibilitätsprüfung</h4>
		<p>
			Wird nur angezeigt, wenn Validierungsfehler oder -warnungen vorhanden sind:
		</p>
		<ul>
			<li><span style="color: red;"><strong>Fehler</strong></span> – müssen korrigiert werden</li>
			<li><span style="color: orange;"><strong>Warnungen</strong></span> – sollten geprüft werden</li>
			<li><span style="color: gray;"><strong>Informationen</strong></span> – Hinweise zur Datenqualität</li>
			<li><strong>Kontrolleur-Kommentare</strong> – Anmerkungen vom Prüfer</li>
		</ul>

		<h3 id="protokoll-kurz">Punktarten mit Kurzprotokoll</h3>
		<p>
			Alle anderen Punktarten haben nur einen vereinfachten Tab:
		</p>
		<h4>Tab: Kurzprotokoll</h4>
		<ul>
			<li>Punktart, Kartierer, Datum</li>
			<li>Forstamt, Revier, Abteilung, Forstbetrieb</li>
			<li>HBF, FBF, Wasserform, Humusform</li>
			<li>Bemerkungen</li>
		</ul>

		<div class="tip">
			<strong>Vorschlagslisten:</strong> Die meisten Felder haben Autovervollständigung.
			Tippen Sie die ersten Buchstaben und wählen Sie aus den Vorschlägen – das spart
			Zeit und vermeidet Tippfehler!
		</div>

		<div class="warning">
			<strong>Regelmäßig speichern:</strong> Klicken Sie regelmäßig auf
			<i class="bi bi-download"></i> <strong>Punkt Speichern</strong> im Menü.
			Im Offline-Modus werden Daten lokal gespeichert und später synchronisiert.
		</div>

		<h3 id="protokoll-kontrolle">Kontrollmechanismus (Kommentare)</h3>
		<p>
			Das Kontrollsystem ermöglicht eine strukturierte Qualitätssicherung der Bohrpunktprotokolle
			durch einen Prüfworkflow zwischen Kontrolleur und Kartierer.
		</p>

		<h4>Rollen im Kontrollprozess</h4>
		<ul>
			<li><strong>Kontrolleur:</strong> Prüft Protokolle, erstellt Kommentare, kann Schweregrad und Status ändern, kann Kommentare löschen</li>
			<li><strong>Kartierer:</strong> Sieht Kommentare, kann auf Kommentare antworten, korrigiert Daten entsprechend der Anmerkungen</li>
		</ul>

		<h4>Kommentieren aktivieren</h4>
		<p>
			In der Benutzerrolle eines Kontrollierenden erscheint in den Detailansichten am oberen
			Bildschirmrand eine Werkzeugleiste mit zwei Modi:
		</p>
		<ul>
			<li><i class="bi bi-pencil-square"></i> <strong>Eintragen-Modus:</strong> Normale Dateneingabe in die Protokollfelder</li>
			<li><i class="bi bi-chat-dots"></i> <strong>Kommentieren-Modus:</strong> Felder können mit Kommentaren versehen werden</li>
		</ul>
		<p>
			Im Kommentieren-Modus stehen zusätzliche Werkzeuge zur Verfügung:
		</p>
		<ul>
			<li><span style="color: red;"><i class="bi bi-pen"></i></span> <strong>Rot (Fehler):</strong> Markiert fehlerhafte Einträge, die korrigiert werden müssen</li>
			<li><span style="color: orange;"><i class="bi bi-pen"></i></span> <strong>Orange (Warnung):</strong> Markiert Einträge, die geprüft werden sollten</li>
			<li><span style="color: gray;"><i class="bi bi-pen"></i></span> <strong>Grau (Info):</strong> Rein informative Anmerkungen ohne Handlungsbedarf</li>
			<li><i class="bi bi-eraser"></i> <strong>Radiergummi:</strong> Entfernt Kommentare von Feldern</li>
		</ul>

		<h4>Kommentare erstellen</h4>
		<p>
			Nach Aktivierung des Kommentieren-Modus und Auswahl einer Farbe klicken Sie auf ein beliebiges
			Datenfeld. Es erscheint ein farbiger Kommentarbereich unter dem Feld, in dem Sie Ihren
			Kommentar eingeben können.
		</p>

		<h4>Kommentar-Detailansicht (Modal)</h4>
		<p>
			Durch Klick auf das <i class="bi bi-chat-left-text"></i> Chat-Symbol neben einem Kommentar
			öffnet sich die Detailansicht mit erweiterten Optionen:
		</p>
		<ul>
			<li><strong>Schweregrad ändern:</strong> Drei Buttons zur Auswahl des Schweregrades (Rot/Orange/Blau)</li>
			<li><strong>Status:</strong> Kommentar als "Offen" oder "Erledigt" markieren</li>
			<li><strong>Antworten:</strong> Auf einen Kommentar antworten (nur wenn der letzte Kommentar nicht von Ihnen ist)</li>
			<li><strong>Löschen:</strong> Gesamten Kommentarverlauf löschen (nur möglich, wenn noch keine Antwort erfolgt ist)</li>
		</ul>

		<h4>Rücklauf-System (Chat-Verlauf)</h4>
		<p>
			Kommentare eines Kontrolleurs können vom Kartierer beantwortet werden. So entsteht ein
			Chat-Verlauf zu jedem kommentierten Feld:
		</p>
		<ol>
			<li>Kontrolleur erstellt Kommentar: "Wert erscheint zu hoch, bitte prüfen"</li>
			<li>Kartierer antwortet: "Wert wurde vor Ort bestätigt, Messung korrekt"</li>
			<li>Kontrolleur markiert als "Erledigt" oder fügt weitere Anmerkung hinzu</li>
		</ol>
		<p>
			<strong>Hinweis:</strong> Sobald ein Kartierer auf einen Kommentar geantwortet hat, kann der
			Kontrolleur den gesamten Kommentarverlauf nicht mehr löschen. Dies stellt sicher, dass die
			Kommunikation dokumentiert bleibt.
		</p>

		<h4>Kommentar-Indikatoren</h4>
		<p>
			Felder mit Kommentaren werden visuell hervorgehoben:
		</p>
		<ul>
			<li>In der Protokollansicht erscheint eine farbige Unterstreichung unter kommentierten Werten</li>
			<li>Bei zusammengesetzten Feldern (z.B. STFG, Relief, Wasserform) zeigt der Indikator an, wenn eines der Teilfelder kommentiert wurde</li>
			<li>In der Punkteliste zeigen kleine farbige Punkte am Protokoll-Button den höchsten Schweregrad offener Kommentare an</li>
		</ul>

		<h4>Plausibilitätsprüfung mit Kommentaren</h4>
		<p>
			Im Tab "Plausibilitätsprüfung" werden alle Kommentare eines Protokolls übersichtlich aufgelistet,
			gruppiert nach Schweregrad. Von hier aus können Sie direkt zu den kommentierten Feldern navigieren.
		</p>

		<h4>Kommentare automatisch speichern</h4>
		<p>
			Alle Änderungen an Kommentaren werden automatisch gespeichert. Sie müssen nicht manuell
			speichern, wenn Sie Kommentare erstellen, beantworten oder den Status ändern.
		</p>

		<h3 id="protokoll-pdf">Protokoll als PDF exportieren</h3>
		<p>
			Sie können einzelne Protokolle direkt aus der Protokollansicht als PDF speichern:
		</p>
		<ul>
			<li>Öffnen Sie das Protokoll eines Bohrpunkts</li>
			<li>Klicken Sie auf <i class="bi bi-printer"></i> <strong>Drucken</strong> in der Werkzeugleiste</li>
			<li>Im Dialog wählen Sie "Als PDF speichern" für den PDF-Export</li>
		</ul>
		<p>
			Das Protokoll wird im A4-Hochformat formatiert und enthält alle relevanten Daten
			inklusive Substratfolge, Horizonte und Vegetation.
		</p>
	</section>

	<!-- ====== 11. IMPORT ====== -->
	<section id="import">
		<h2>10. Datenimport</h2>
		<p>
			BpWeb bietet drei Import-Methoden. Der <strong>Import-Assistent</strong> ist die
			empfohlene und umfangreichste Variante.
		</p>

		<h3 id="import-assistent">Import-Assistent (empfohlen)</h3>
		<p>
			Der Import-Assistent führt Sie durch den Importprozess und unterstützt mehrere Formate:
		</p>
		<table class="shortcut-table">
			<tr>
				<th>Format</th>
				<th>Dateitypen</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Excel</strong></td>
				<td>.xlsx, .xls, .xlsm, .xlsb</td>
				<td>Bohrpunkt- und Moorpunkt-Protokolle</td>
			</tr>
			<tr>
				<td><strong>GeoPackage</strong></td>
				<td>.gpkg</td>
				<td>Punkt-Layer mit Attributen</td>
			</tr>
			<tr>
				<td><strong>GeoJSON</strong></td>
				<td>.geojson, .json</td>
				<td>FeatureCollections mit Point-Features</td>
			</tr>
		</table>

		<h4>Funktionen des Import-Assistenten:</h4>
		<ul>
			<li><strong>Automatische Format-Erkennung:</strong> Unterscheidet Bohrpunkt- und Moorpunkt-Formate</li>
			<li><strong>Duplikat-Prüfung:</strong> Erkennt bereits existierende Punkte anhand von:
				<ul>
					<li>Koordinaten (Entfernung &lt; 5m) – höchste Priorität</li>
					<li>Kombination aus Nummer + Datum + Kartierer</li>
				</ul>
			</li>
			<li><strong>Validierung:</strong> Zeigt Warnungen und Fehler vor dem Import</li>
			<li><strong>Vorschau:</strong> Prüfen Sie die Daten vor dem endgültigen Import</li>
			<li><strong>Duplikat-Optionen:</strong>
				<ul>
					<li><em>Überspringen:</em> Duplikate werden nicht importiert</li>
					<li><em>Aktualisieren:</em> Bestehende Punkte werden überschrieben</li>
					<li><em>Beide behalten:</em> Neuer Punkt wird zusätzlich angelegt</li>
				</ul>
			</li>
			<li><strong>Koordinaten-Transformation:</strong> Automatische Umrechnung zwischen EPSG:25833, EPSG:5650 und WGS84</li>
			<li><strong>Vegetations-Matching:</strong> Fuzzy-Suche für Vegetationsnamen</li>
		</ul>

		<h4>GeoPackage/GeoJSON-Feldmapping:</h4>
		<table class="shortcut-table">
			<tr>
				<th>Quellfeld</th>
				<th>Zielfeld</th>
			</tr>
			<tr>
				<td>SYMBOL</td>
				<td>Punktart (6=Tiefbohrung, 7=Moorpunkt, etc.)</td>
			</tr>
			<tr>
				<td>SYM_TEXT</td>
				<td>Nummer oder Bemerkungen</td>
			</tr>
			<tr>
				<td>HBF, BF, HF</td>
				<td>Bodenform, Humusform</td>
			</tr>
		</table>

		<h3 id="import-verzeichnisse">Import (Verzeichnisse)</h3>
		<p>
			Legacy-Methode zum Import ganzer Verzeichnisse mit Excel-Dateien:
		</p>
		<ul>
			<li>Wählt einen Ordner aus (mit Unterordnern)</li>
			<li>Importiert alle .xls*-Dateien rekursiv</li>
			<li>Nur numerische Sheet-Namen (1, 2, 3...)</li>
		</ul>

		<h3 id="import-dateien">Import (Dateien)</h3>
		<p>
			Legacy-Methode zum Import einzelner Excel-Dateien.
			Identische Verarbeitung wie "Import (Verzeichnisse)".
		</p>

		<div class="tip">
			<strong>Empfehlung:</strong> Nutzen Sie immer den Import-Assistenten! Er bietet
			die beste Kontrolle über den Importprozess und unterstützt die meisten Formate.
		</div>
	</section>

	<!-- ====== 12. EXPORT ====== -->
	<section id="export">
		<h2>11. Datenexport</h2>
		<p>
			BpWeb bietet drei Export-Formate für unterschiedliche Zwecke.
		</p>

		<h3 id="export-json">Export Protokolle (JSON)</h3>
		<p>
			Exportiert vollständige Punktdaten als JSON-Datei.
		</p>
		<ul>
			<li><strong>Dateiname:</strong> Bohrpunkte_Protokolle.json</li>
			<li><strong>Inhalt:</strong> Alle Felder inkl. Substrate, Horizonte, Vegetation</li>
			<li><strong>Verwendung:</strong> Datensicherung, Datenanalyse, Weiterverarbeitung</li>
		</ul>

		<p><strong>Welche Punkte werden exportiert?</strong></p>
		<ol>
			<li>Ausgewählte Punkte (wenn Auswahl vorhanden)</li>
			<li>Punkte im aktuellen Kartenausschnitt (wenn keine Auswahl)</li>
			<li>Alle gefilterten Punkte (Fallback)</li>
		</ol>

		<h3 id="export-geojson">Export Kartendaten (GeoJSON)</h3>
		<p>
			Exportiert Punkte und Zeichnungen als GeoJSON für GIS-Anwendungen.
		</p>
		<ul>
			<li><strong>Punkte.geojson:</strong> Bohrpunkte als Point-Features</li>
			<li><strong>Zeichnungen_Linien.geojson:</strong> Linien-Geometrien</li>
			<li><strong>Zeichnungen_Polygone.geojson:</strong> Polygon-Geometrien</li>
		</ul>

		<p><strong>GeoJSON-Attribute:</strong></p>
		<table class="shortcut-table">
			<tr>
				<th>Attribut</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td>SYM_TEXT</td>
				<td>Bohrpunktnummer</td>
			</tr>
			<tr>
				<td>SYMBOL</td>
				<td>Punktart-ID</td>
			</tr>
			<tr>
				<td>HF</td>
				<td>Humusform / Vegetationsformengruppe</td>
			</tr>
			<tr>
				<td>HBF</td>
				<td>Hauptbodenform</td>
			</tr>
			<tr>
				<td>BF</td>
				<td>Bodenform (Label)</td>
			</tr>
			<tr>
				<td>Bemerkungen</td>
				<td>Bemerkungstexte</td>
			</tr>
		</table>

		<h3 id="export-pdf">Export als PDF</h3>
		<p>
			Erstellt druckbare Protokollblätter im A4-Hochformat.
		</p>
		<ul>
			<li><strong>Voraussetzung:</strong> Mindestens ein Punkt muss ausgewählt sein</li>
			<li><strong>Druckvorschau:</strong> Zeigt alle Protokolle vor dem Export</li>
			<li><strong>Mehrseitig:</strong> Jeder Punkt auf einer eigenen Seite</li>
		</ul>

		<div class="tip">
			<strong>GeoJSON in QGIS:</strong> Die exportierten GeoJSON-Dateien können direkt
			in QGIS, ArcGIS oder Google Earth importiert werden. Das Koordinatensystem ist WGS84.
		</div>

		<div class="info">
			<strong>Speicherort wählen:</strong> Auf Desktop-Geräten öffnet sich ein Speicherdialog.
			Auf mobilen Geräten wird die Teilen-Funktion genutzt oder ein automatischer Download gestartet.
		</div>
	</section>

	<!-- ====== 13. OFFLINE ====== -->
	<section id="offline">
		<h2>12. Offline-Modus</h2>
		<p>
			BpWeb ist für die Arbeit ohne Internetverbindung optimiert. Bereiten Sie Ihre Projekte
			vor, und arbeiten Sie vollständig offline im Gelände.
		</p>

		<h3 id="offline-voraussetzungen">Voraussetzungen für Offline-Arbeit</h3>
		<p>
			Um offline arbeiten zu können, müssen <strong>alle</strong> folgenden Bedingungen erfüllt sein:
		</p>
		<table class="shortcut-table">
			<tr>
				<th>Bedingung</th>
				<th>Warum nötig?</th>
				<th>Prüfung</th>
			</tr>
			<tr>
				<td><strong>1. Angemeldet</strong></td>
				<td>Authentifizierung wird lokal gespeichert</td>
				<td>Benutzername oben rechts sichtbar</td>
			</tr>
			<tr>
				<td><strong>2. Projekt geöffnet</strong></td>
				<td>Projekt definiert, welche Daten benötigt werden</td>
				<td>Projektname im Panel sichtbar</td>
			</tr>
			<tr>
				<td><strong>3. Bereiche definiert</strong></td>
				<td>Bereiche bestimmen, welche Karten-Tiles geladen werden</td>
				<td>Mind. 1 Bereich im Bereiche-Akkordeon</td>
			</tr>
			<tr>
				<td><strong>4. Karten-Tiles geladen</strong></td>
				<td>OSM/WMS für Navigation und Fachdaten</td>
				<td><i class="bi bi-cloud-check" style="color: green"></i> bei OSM- und WMS-Layern</td>
			</tr>
			<tr>
				<td><strong>5. Punkte synchronisiert</strong></td>
				<td>Bohrpunkte für Anzeige und Bearbeitung</td>
				<td>Download-Dialog zeigt "Punkte: OK"</td>
			</tr>
			<tr>
				<td><strong>6. Geodaten vorhanden</strong></td>
				<td>GeoPackage/GeoJSON für Zusatzinformationen</td>
				<td><i class="bi bi-check-lg" style="color: green"></i> bei allen GPKG-Layern</td>
			</tr>
		</table>

		<div class="tip">
			<strong>WMS-Dienste können heruntergeladen werden:</strong> Wie OSM-Karten können auch WMS-Layer
			für den Offline-Betrieb heruntergeladen werden. Die Kacheln werden lokal gespeichert und stehen
			dann auch ohne Internetverbindung zur Verfügung. Achten Sie auf den Download-Status
			<i class="bi bi-cloud-check" style="color: green"></i> bei jedem WMS-Layer.
		</div>

		<h3 id="offline-vorbereiten">Schritt-für-Schritt: Offline vorbereiten</h3>
		<div class="info">
			<strong>Empfehlung:</strong> Führen Sie diese Schritte am Vortag im Büro durch,
			idealerweise über WLAN. Der Download großer Projektbereiche kann je nach Größe
			mehrere Minuten dauern.
		</div>

		<h4>Schritt 1: Anmelden (online)</h4>
		<ol>
			<li>Öffnen Sie BpWeb im Browser</li>
			<li>Melden Sie sich mit Ihren Zugangsdaten an</li>
			<li>Warten Sie, bis Ihr Name oben rechts angezeigt wird</li>
		</ol>

		<h4>Schritt 2: Projekt öffnen</h4>
		<ol>
			<li>Klicken Sie auf das Projekt-Dropdown im linken Panel</li>
			<li>Wählen Sie Ihr Arbeitsprojekt aus</li>
			<li>Warten Sie, bis das Projekt vollständig geladen ist</li>
		</ol>

		<h4>Schritt 3: Projektbereiche prüfen/definieren</h4>
		<ol>
			<li>Öffnen Sie den Akkordeon-Bereich <strong>Bereiche</strong></li>
			<li>Falls keine Bereiche vorhanden sind:
				<ul>
					<li>Klicken Sie auf <i class="bi bi-square"></i> <strong>Rechteck</strong> und ziehen Sie ein Rechteck auf der Karte auf</li>
					<li>Oder klicken Sie auf <i class="bi bi-pentagon"></i> <strong>Polygon</strong> und zeichnen Sie einen Bereich ein</li>
				</ul>
			</li>
			<li>Prüfen Sie, dass alle benötigten Gebiete als Bereiche definiert sind</li>
		</ol>

		<h4>Schritt 4: Geodaten hinzufügen (optional)</h4>
		<ol>
			<li>Öffnen Sie den <strong>Layerstore</strong> (Button im Layer-Bereich)</li>
			<li>Fügen Sie benötigte GeoPackage- oder GeoJSON-Dateien hinzu</li>
			<li>Schließen Sie den Layerstore</li>
		</ol>

		<h4>Schritt 5: Offline bereitstellen</h4>
		<ol>
			<li>Klicken Sie auf das Drei-Punkte-Menü <i class="bi bi-three-dots-vertical"></i> neben dem Projektnamen</li>
			<li>Wählen Sie <i class="bi bi-cloud-download"></i> <strong>Download</strong></li>
			<li>Im Dialog "Offline bereitstellen":
				<ul>
					<li>Wählen Sie die <strong>Zoomstufen</strong> (Plus-Level 0-2)</li>
					<li>Klicken Sie auf <strong>Herunterladen</strong></li>
				</ul>
			</li>
			<li>Warten Sie, bis der Download abgeschlossen ist (Fortschrittsanzeige)</li>
			<li>Bei Bedarf können Sie den Download mit <strong>Abbrechen</strong> stoppen – bereits
				heruntergeladene Tiles bleiben erhalten und können beim nächsten Mal fortgesetzt werden</li>
		</ol>

		<h4>Schritt 6: Status prüfen</h4>
		<ol>
			<li>Prüfen Sie im Layer-Bereich:
				<ul>
					<li>OSM-Layer: <i class="bi bi-cloud-check" style="color: green"></i> (grün = vollständig)</li>
					<li>GPKG-Layer: <i class="bi bi-check-lg" style="color: green"></i> (grün = Datei vorhanden)</li>
				</ul>
			</li>
			<li>Wenn alle Symbole grün sind, ist das Projekt bereit für Offline-Arbeit</li>
		</ol>

		<h4>Schritt 7: In den Offline-Modus wechseln</h4>
		<ol>
			<li>Im Projekt-Panel erscheint der Button <strong class="text-success">Offline arbeiten</strong></li>
			<li>Klicken Sie darauf, um in den Offline-Modus zu wechseln</li>
			<li>BpWeb arbeitet jetzt vollständig lokal</li>
		</ol>

		<div class="warning">
			<strong>Wichtig:</strong> Der Button "Offline arbeiten" erscheint nur, wenn das Projekt
			vollständig heruntergeladen wurde. Ist er nicht sichtbar, prüfen Sie die obigen Schritte.
		</div>

		<h3 id="offline-download">Was wird heruntergeladen?</h3>
		<table class="shortcut-table">
			<tr>
				<th>Komponente</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Karten-Tiles (OSM)</strong></td>
				<td>OpenStreetMap-Basiskarte für Ihre Projektbereiche</td>
			</tr>
			<tr>
				<td><strong>Karten-Tiles (WMS)</strong></td>
				<td>WMS-Dienste (z.B. Luftbilder, Forstkarten) für Ihre Projektbereiche</td>
			</tr>
			<tr>
				<td><strong>Punkte</strong></td>
				<td>Alle Bohrpunkte nach Ihren Filtern und Bereichen</td>
			</tr>
			<tr>
				<td><strong>Geodaten</strong></td>
				<td>GeoPackage, GeoTIFF, GeoJSON aus dem Layerstore</td>
			</tr>
			<tr>
				<td><strong>Zeichnungen</strong></td>
				<td>Ihre Zeichnungslayer mit allen Geometrien</td>
			</tr>
		</table>

		<h3 id="offline-detail">Download-Detaillierungsgrad</h3>
		<p>
			Beim Download können Sie die Zoom-Tiefe wählen (Plus-Level 0-2):
		</p>
		<ul>
			<li><strong>0:</strong> Basis-Zoomstufen (weniger Speicher, gröbere Details)</li>
			<li><strong>1:</strong> Mittlere Detailtiefe (empfohlen)</li>
			<li><strong>2:</strong> Maximale Details (mehr Speicher, feinste Auflösung)</li>
		</ul>

		<h3 id="offline-arbeiten">Offline arbeiten</h3>
		<p>
			Sobald der Download abgeschlossen ist, können Sie BpWeb ohne Internet nutzen:
		</p>
		<ul>
			<li>Punkte erfassen und bearbeiten</li>
			<li>Zeichnungen erstellen</li>
			<li>GPS-Tracking nutzen</li>
			<li>Alle Daten werden lokal in PouchDB gespeichert</li>
		</ul>

		<h3 id="offline-sync">Synchronisation – Zurück in den Online-Modus</h3>
		<p>
			Wenn Sie nach der Geländearbeit wieder Internetverbindung haben und Ihre Daten
			mit dem Server abgleichen möchten, klicken Sie auf <strong class="text-primary">Synchronisieren</strong>.
			Es öffnet sich ein Dialog mit drei Optionen:
		</p>

		<table class="shortcut-table">
			<tr>
				<th>Option</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Synchronisieren & Online gehen</strong></td>
				<td>Überträgt alle lokalen Änderungen zum Server und wechselt zurück in den Online-Modus. <em>Empfohlene Option.</em></td>
			</tr>
			<tr>
				<td><strong>Nur synchronisieren (offline bleiben)</strong></td>
				<td>Überträgt Änderungen zum Server, bleibt aber im Offline-Modus.</td>
			</tr>
			<tr>
				<td><strong style="color: red">Änderungen verwerfen & Online gehen</strong></td>
				<td>Verwirft alle lokalen Änderungen unwiderruflich und wechselt in den Online-Modus. <em>Vorsicht: Datenverlust!</em></td>
			</tr>
		</table>

		<div class="warning">
			<strong>Achtung bei "Änderungen verwerfen":</strong> Diese Option löscht alle Ihre
			offline erfassten Daten unwiderruflich! Nutzen Sie diese nur, wenn Sie sicher sind,
			dass Sie die lokalen Änderungen nicht mehr benötigen.
		</div>

		<div class="warning">
			<strong>Niemals Browser-Daten löschen!</strong> Solange Sie offline gearbeitet haben
			und noch nicht synchronisiert haben, sind Ihre Daten nur lokal vorhanden. Das Löschen
			des Browser-Cache würde diese Daten unwiderruflich vernichten!
		</div>

		<div class="tip">
			<strong>Persistenter Speicher:</strong> BpWeb fordert beim Browser "persistenten Speicher"
			an. Das bedeutet, dass Ihre Daten auch bei Speicherplatzmangel nicht automatisch gelöscht
			werden. Prüfen Sie den Status in der Navigationsleiste.
		</div>
	</section>

	<!-- ====== 14. STATUSANZEIGEN ====== -->
	<section id="statusanzeigen">
		<h2>13. Statusanzeigen</h2>
		<p>
			In der Navigationsleiste oben zeigen verschiedene Symbole den aktuellen Systemstatus.
		</p>

		<h3 id="status-verbindung">Verbindungsstatus</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Bedeutung</th>
			</tr>
			<tr>
				<td><i class="bi bi-wifi"></i></td>
				<td><strong>Online</strong> – Verbindung zum Server besteht</td>
			</tr>
			<tr>
				<td><i class="bi bi-wifi-off" style="color: red"></i></td>
				<td><strong>Offline</strong> – Keine Serververbindung</td>
			</tr>
		</table>

		<h3 id="status-speicher">Speicherstatus</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Bedeutung</th>
			</tr>
			<tr>
				<td><i class="bi bi-database"></i> <i class="bi bi-check" style="color: green"></i></td>
				<td><strong>Persistenter Speicher</strong> – Daten sind sicher</td>
			</tr>
			<tr>
				<td><i class="bi bi-database"></i> <i class="bi bi-exclamation-triangle-fill" style="color: orange"></i></td>
				<td><strong>Temporärer Speicher</strong> – Browser könnte Daten löschen</td>
			</tr>
		</table>

		<h3 id="status-gps">GPS-Status</h3>
		<table class="shortcut-table">
			<tr>
				<th>Symbol</th>
				<th>Bedeutung</th>
			</tr>
			<tr>
				<td><i class="bi bi-geo-alt"></i> <i class="bi bi-check" style="color: green"></i></td>
				<td><strong>GPS aktiv</strong> – Gute Genauigkeit</td>
			</tr>
			<tr>
				<td><i class="bi bi-geo-alt"></i> <i class="bi bi-exclamation-triangle-fill" style="color: orange"></i></td>
				<td><strong>GPS ungenau</strong> – Position verfügbar, geringe Genauigkeit</td>
			</tr>
			<tr>
				<td><i class="bi bi-geo-alt"></i> <i class="bi bi-speedometer2" style="color: orange"></i></td>
				<td><strong>GPS langsam</strong> – Positionsdaten veraltet</td>
			</tr>
			<tr>
				<td><i class="bi bi-geo-alt"></i> <i class="bi bi-x-square-fill" style="color: red"></i></td>
				<td><strong>Kein GPS</strong> – Nicht verfügbar oder keine Berechtigung</td>
			</tr>
		</table>

		<div class="tip">
			<strong>GPS verbessern:</strong> Gehen Sie ins Freie und warten Sie einen Moment.
			Unter Bäumen oder in Gebäuden ist der GPS-Empfang oft schlecht.
		</div>
	</section>

	<!-- ====== 15. TECHNISCHER HINTERGRUND ====== -->
	<section id="technik">
		<h2>14. Technischer Hintergrund</h2>
		<p>
			Für technisch Interessierte ein Überblick über die verwendeten Technologien
			und die Architektur von BpWeb.
		</p>
		<p><em>Dieses Handbuch gilt für BpWeb Version 1.5.13.</em></p>

		<h3 id="technik-architektur">Systemarchitektur</h3>
		<p>BpWeb basiert auf einer Client-Server-Architektur mit Offline-Fähigkeit:</p>
		<table class="shortcut-table">
			<tr>
				<th>Komponente</th>
				<th>Technologie</th>
				<th>Aufgabe</th>
			</tr>
			<tr>
				<td><strong>Frontend</strong></td>
				<td>Angular 17+ / TypeScript</td>
				<td>Benutzeroberfläche im Browser</td>
			</tr>
			<tr>
				<td><strong>Lokale Datenbank</strong></td>
				<td>PouchDB (IndexedDB)</td>
				<td>Offline-Speicherung im Browser</td>
			</tr>
			<tr>
				<td><strong>Server-Datenbank</strong></td>
				<td>CouchDB</td>
				<td>Zentrale Datenhaltung und Synchronisation</td>
			</tr>
			<tr>
				<td><strong>Authentifizierung</strong></td>
				<td>Keycloak</td>
				<td>Benutzerverwaltung und Single Sign-On</td>
			</tr>
			<tr>
				<td><strong>Karten</strong></td>
				<td>Leaflet</td>
				<td>Interaktive Kartendarstellung</td>
			</tr>
			<tr>
				<td><strong>Tile-Cache</strong></td>
				<td>localForage</td>
				<td>Offline-Speicherung von Kartenkacheln</td>
			</tr>
		</table>

		<h3 id="technik-datenfluss">Datenfluss</h3>
		<p>So fließen die Daten durch das System:</p>
		<ol>
			<li><strong>Erfassung:</strong> Benutzer gibt Daten ein → Speicherung in PouchDB (lokal)</li>
			<li><strong>Synchronisation:</strong> Bei Verbindung → Replikation zu CouchDB (Server)</li>
			<li><strong>Verteilung:</strong> Andere Benutzer → Empfangen Änderungen via CouchDB</li>
		</ol>
		<div class="info">
			<strong>Offline-First-Prinzip:</strong> Alle Operationen werden zuerst lokal ausgeführt.
			Die Synchronisation mit dem Server erfolgt im Hintergrund, sobald eine Verbindung besteht.
			Das garantiert schnelle Reaktionszeiten – auch bei langsamer oder instabiler Verbindung.
		</div>

		<h3 id="technik-speicherung">Datenspeicherung</h3>
		<p>BpWeb nutzt verschiedene Speichermechanismen im Browser:</p>
		<table class="shortcut-table">
			<tr>
				<th>Speicher</th>
				<th>Verwendung</th>
				<th>Typische Größe</th>
			</tr>
			<tr>
				<td><strong>IndexedDB</strong></td>
				<td>Bohrpunkte, Projekte, Filter, Zeichnungen</td>
				<td>10–100 MB</td>
			</tr>
			<tr>
				<td><strong>localForage</strong></td>
				<td>Kartenkacheln (OSM, WMS)</td>
				<td>100 MB – mehrere GB</td>
			</tr>
			<tr>
				<td><strong>LocalStorage</strong></td>
				<td>Einstellungen, Session-Daten</td>
				<td>&lt; 5 MB</td>
			</tr>
			<tr>
				<td><strong>Cache API</strong></td>
				<td>Anwendungs-Code, Assets</td>
				<td>10–50 MB</td>
			</tr>
		</table>

		<h3 id="technik-geodaten">Geodatenformate</h3>
		<p>BpWeb unterstützt folgende Geodatenformate:</p>
		<table class="shortcut-table">
			<tr>
				<th>Format</th>
				<th>Bibliothek</th>
				<th>Eigenschaften</th>
			</tr>
			<tr>
				<td><strong>GeoPackage (.gpkg)</strong></td>
				<td>&#64;ngageoint/geopackage</td>
				<td>SQLite-basiert, Vektordaten mit Attributen, Styles</td>
			</tr>
			<tr>
				<td><strong>GeoJSON (.geojson)</strong></td>
				<td>Leaflet (nativ)</td>
				<td>JSON-basiert, einfach zu verarbeiten</td>
			</tr>
			<tr>
				<td><strong>GeoTIFF (.tif)</strong></td>
				<td>georaster-layer-for-leaflet</td>
				<td>Georeferenzierte Rasterbilder</td>
			</tr>
			<tr>
				<td><strong>WMS</strong></td>
				<td>Leaflet.WMS</td>
				<td>Web Map Service, serverbasiert</td>
			</tr>
		</table>

		<h3 id="technik-koordinaten">Koordinatensysteme</h3>
		<p>BpWeb arbeitet intern mit WGS84 (EPSG:4326) und unterstützt die Transformation zu:</p>
		<ul>
			<li><strong>EPSG:25833</strong> – UTM Zone 33N (Brandenburg, Mecklenburg-Vorpommern)</li>
			<li><strong>EPSG:5650</strong> – ETRS89 / UTM zone 33N (mit 33 Mio. Ostwert)</li>
			<li><strong>EPSG:4326</strong> – WGS84 (GPS-Koordinaten)</li>
		</ul>
		<p>Die Transformation erfolgt mit der Bibliothek <strong>proj4js</strong>.</p>

		<h3 id="technik-pwa">Progressive Web App (PWA)</h3>
		<p>BpWeb ist als Progressive Web App konzipiert:</p>
		<table class="shortcut-table">
			<tr>
				<th>Funktion</th>
				<th>Beschreibung</th>
			</tr>
			<tr>
				<td><strong>Installierbar</strong></td>
				<td>Zum Startbildschirm hinzufügen ohne App Store</td>
			</tr>
			<tr>
				<td><strong>Service Worker</strong></td>
				<td>Caching der Anwendung für Offline-Start</td>
			</tr>
			<tr>
				<td><strong>Responsive Design</strong></td>
				<td>Automatische Anpassung an Desktop, Tablet, Smartphone</td>
			</tr>
			<tr>
				<td><strong>Auto-Update</strong></td>
				<td>Neue Versionen werden automatisch im Hintergrund geladen</td>
			</tr>
			<tr>
				<td><strong>Persistenter Speicher</strong></td>
				<td>Anforderung von dauerhaftem Speicher beim Browser</td>
			</tr>
		</table>

		<h3 id="technik-sicherheit">Sicherheit</h3>
		<table class="shortcut-table">
			<tr>
				<th>Aspekt</th>
				<th>Umsetzung</th>
			</tr>
			<tr>
				<td><strong>Authentifizierung</strong></td>
				<td>OAuth 2.0 / OpenID Connect via Keycloak</td>
			</tr>
			<tr>
				<td><strong>Verschlüsselung</strong></td>
				<td>HTTPS für alle Server-Kommunikation</td>
			</tr>
			<tr>
				<td><strong>Berechtigungen</strong></td>
				<td>Rollenbasiert (Bearbeiter, Kontrolleur, Manager)</td>
			</tr>
			<tr>
				<td><strong>Session</strong></td>
				<td>JWT-Token mit automatischer Erneuerung</td>
			</tr>
		</table>

		<h3 id="technik-bibliotheken">Open-Source-Bibliotheken</h3>
		<p>BpWeb verwendet ausschließlich Open-Source-Technologien:</p>
		<table class="shortcut-table">
			<tr>
				<th>Bibliothek</th>
				<th>Version</th>
				<th>Lizenz</th>
			</tr>
			<tr>
				<td>Angular</td>
				<td>17+</td>
				<td>MIT</td>
			</tr>
			<tr>
				<td>PouchDB</td>
				<td>8.x</td>
				<td>Apache 2.0</td>
			</tr>
			<tr>
				<td>Leaflet</td>
				<td>1.9.x</td>
				<td>BSD-2-Clause</td>
			</tr>
			<tr>
				<td>Bootstrap / ngx-bootstrap</td>
				<td>5.x / 12.x</td>
				<td>MIT</td>
			</tr>
			<tr>
				<td>proj4js</td>
				<td>2.x</td>
				<td>MIT</td>
			</tr>
			<tr>
				<td>localForage</td>
				<td>1.x</td>
				<td>Apache 2.0</td>
			</tr>
		</table>

		<h3 id="technik-browser">Browser-Kompatibilität</h3>
		<table class="shortcut-table">
			<tr>
				<th>Browser</th>
				<th>Status</th>
				<th>Hinweise</th>
			</tr>
			<tr>
				<td>Google Chrome (Desktop & Android)</td>
				<td><span style="color: green;">✓ Vollständig</span></td>
				<td>Empfohlen für Geländearbeit</td>
			</tr>
			<tr>
				<td>Mozilla Firefox</td>
				<td><span style="color: green;">✓ Vollständig</span></td>
				<td>–</td>
			</tr>
			<tr>
				<td>Microsoft Edge</td>
				<td><span style="color: green;">✓ Vollständig</span></td>
				<td>Chromium-basiert</td>
			</tr>
			<tr>
				<td>Safari (macOS)</td>
				<td><span style="color: green;">✓ Unterstützt</span></td>
				<td>–</td>
			</tr>
			<tr>
				<td>Safari (iOS/iPadOS)</td>
				<td><span style="color: orange;">⚠ Eingeschränkt</span></td>
				<td>Speicher-Limits, kein persistenter Speicher</td>
			</tr>
		</table>

		<div class="warning">
			<strong>Safari auf iOS:</strong> Apple begrenzt den Offline-Speicher stärker als
			andere Browser (ca. 1 GB). Für intensive Geländearbeit mit großen Projektbereichen
			empfehlen wir Android-Geräte mit Chrome.
		</div>

		<h3 id="technik-system">Systemanforderungen</h3>
		<table class="shortcut-table">
			<tr>
				<th>Komponente</th>
				<th>Minimum</th>
				<th>Empfohlen</th>
			</tr>
			<tr>
				<td><strong>Browser</strong></td>
				<td>Chrome 90+, Firefox 90+, Edge 90+</td>
				<td>Aktuellste Version</td>
			</tr>
			<tr>
				<td><strong>Arbeitsspeicher</strong></td>
				<td>2 GB RAM</td>
				<td>4+ GB RAM</td>
			</tr>
			<tr>
				<td><strong>Speicherplatz</strong></td>
				<td>500 MB frei</td>
				<td>2+ GB frei (für Offline-Daten)</td>
			</tr>
			<tr>
				<td><strong>Bildschirm</strong></td>
				<td>320px Breite</td>
				<td>768px+ für optimale Darstellung</td>
			</tr>
			<tr>
				<td><strong>GPS</strong></td>
				<td>Optional</td>
				<td>Für Geländearbeit empfohlen</td>
			</tr>
		</table>
	</section>

	<footer style="margin-top: 3rem; padding-top: 1rem; border-top: 1px solid #dee2e6; color: #6c757d; text-align: center;">
		<p>BpWeb Benutzerhandbuch • Version 3.0</p>
		<p style="font-size: 0.9rem;">
			Bei Fragen wenden Sie sich an Ihren Projektmanager oder den technischen Support.
		</p>
	</footer>
	</main>

	<!-- Schwebender Nach-oben-Button -->
	<button *ngIf="showScrollTopButton" class="scroll-top-btn" (click)="scrollToTop()" title="Ganz nach oben">
		<i class="bi bi-arrow-up"></i>
	</button>
</div>
